// Подписи пунктов «Стоимость» и «Кампусы» задаём по href: для Узбекистана DOM
// переставляется (Ташкент вторым). Индексы dropdownLinks[1]…[5] тогда не совпадают
// с порядком из шаблона — повторный translate вешал «Ташкент» на ссылку СПб.
function setNavFeeDropdownTextsByHref(dropdownMenu, t) {
  dropdownMenu.querySelectorAll('li a').forEach((a) => {
    const href = a.getAttribute('href') || '';
    if (href.includes('admissions/tuition-fees')) a.textContent = t.nav_cost_tuition;
    else if (href.includes('campuses/tashkent/tuition-fees')) a.textContent = t.nav_cost_tashkent;
    else if (href.includes('campuses/spb/tuition-fees')) a.textContent = t.nav_cost_spb;
    else if (href.includes('campuses/moscow/tuition-fees')) a.textContent = t.nav_cost_moscow;
    else if (href.includes('campuses/gorki/tuition-fees')) a.textContent = t.nav_cost_gorki;
    else if (href.includes('campuses/skolkovo/tuition-fees')) a.textContent = t.nav_cost_skolkovo;
  });
}

function setNavCampusesDropdownTextsByHref(dropdownMenu, t) {
  dropdownMenu.querySelectorAll('li a').forEach((a) => {
    const href = a.getAttribute('href') || '';
    if (href.includes('/campuses/tashkent/')) a.textContent = t.nav_campuses_tashkent;
    else if (href.includes('/campuses/spb/')) a.textContent = t.nav_campuses_spb;
    else if (href.includes('/campuses/moscow/')) a.textContent = t.nav_campuses_moscow;
    else if (href.includes('/campuses/gorki/')) a.textContent = t.nav_campuses_gorki;
    else if (href.includes('/campuses/skolkovo/')) a.textContent = t.nav_campuses_skolkovo;
    else a.textContent = t.nav_campuses_all;
  });
}

function translatePage(lang, regionNameOverride) {
  const t = translations[lang];
  if (!t) return;

  // Логотип: только ссылка, без лишнего текстового узла «ШКОЛА» рядом
  const logoBlock = document.querySelector('.top_bar .logo');
  if (logoBlock) {
    const logoTexts = logoBlock.querySelectorAll('.logo_text_top span');
    if (logoTexts.length >= 2) {
      logoTexts[0].textContent = t.logo_cambridge;
      logoTexts[1].textContent = t.logo_international;
    }
    logoBlock.querySelectorAll('.logo_school_row').forEach((schoolRow) => {
      Array.from(schoolRow.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
          node.remove();
        }
      });
      const schoolLink = schoolRow.querySelector('.logo_school_link');
      if (schoolLink) {
        schoolLink.textContent = t.logo_school;
      }
    });
  }
  // Обновляем название региона в зависимости от выбранного региона
  // Приоритет: 1) URL (en-uz/ru-uz), 2) regionNameOverride, 3) cookie
  let currentRegion = 'Россия';
  const pathMatch = typeof window !== 'undefined' && window.location && window.location.pathname
    ? window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(\/.*)?$/)
    : null;
  if (pathMatch && pathMatch[2] === 'uz') {
    currentRegion = pathMatch[1] === 'en' ? 'Uzbekistan' : 'Узбекистан';
  } else if (regionNameOverride) {
    currentRegion = regionNameOverride;
  } else {
    const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
      ? window.getCookie(window.COOKIE_NAME)
      : (typeof getCookie === 'function' && typeof COOKIE_NAME !== 'undefined' ? getCookie(COOKIE_NAME) : null);
    if (saved) {
      try {
        const regionData = JSON.parse(saved);
        currentRegion = regionData.name;
      } catch (e) {
        // Если не удалось распарсить, используем значение по умолчанию
      }
    }
  }
  
  // Обновляем название региона в кнопке с учетом текущего языка
  const curCountry = document.getElementById('curCountry');
  if (curCountry) {
    if (currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan') {
      curCountry.textContent = t.region_uzbekistan;
    } else {
      curCountry.textContent = t.region_russia;
    }
  }
  
  const regionOptions = document.querySelectorAll('.country_option span');
  if (regionOptions.length >= 2) {
    regionOptions[0].textContent = t.region_uzbekistan;
    regionOptions[1].textContent = t.region_russia;
  }
  const modalHeader = document.querySelector('.modal_header');
  if (modalHeader) {
    // Используем правильный текст в зависимости от текущего региона
    if (currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan') {
      modalHeader.innerHTML = t.region_modal_text_uzbekistan;
    } else {
      modalHeader.innerHTML = t.region_modal_text;
    }
  }

  // Навигация - выбираем только прямые дочерние ссылки из меню ul (исключая ссылки в dropdown-menu)
  const navItems = document.querySelectorAll('.nav-bar ul li.bar.dropdown > a');
  if (navItems.length >= 6) {
    navItems[0].textContent = t.nav_world;
    navItems[1].textContent = t.nav_program;
    navItems[2].textContent = t.nav_teachers;
    navItems[3].textContent = t.nav_admission;
    navItems[4].textContent = t.nav_cost;
    navItems[5].textContent = t.nav_campuses;
    if (navItems[6]) navItems[6].textContent = t.nav_media;
  }

  // Подменю навигации
  const dropdownMenus = document.querySelectorAll('.nav-bar ul li.bar.dropdown');
  dropdownMenus.forEach((menuItem, index) => {
    const dropdownLinks = menuItem.querySelectorAll('.dropdown-menu li a');
    
    // Подменю "Мир CIS" (индекс 0)
    if (index === 0 && dropdownLinks.length >= 8) {
      dropdownLinks[0].textContent = t.nav_world_about;
      dropdownLinks[1].textContent = t.nav_world_mission;
      dropdownLinks[2].textContent = t.nav_world_alumni;
      dropdownLinks[3].textContent = t.nav_world_licenses;
      dropdownLinks[4].textContent = t.nav_world_equipment;
      dropdownLinks[5].textContent = t.nav_world_reviews;
      dropdownLinks[6].textContent = t.nav_world_vacancies;
      dropdownLinks[7].textContent = t.nav_world_contacts;
      
      // Пункт "Устав" только для Узбекистана
      const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
      const charterLink = menuItem.querySelector('.js-charter-nav');
      if (charterLink) {
        charterLink.style.display = isUzbekistan ? '' : 'none';
        charterLink.textContent = t.nav_world_charter;
      }
    }
    
    // Подменю "Программа" (индекс 1)
    // В HTML порядок: 0-Международная, 1-Российская программа, 2-Детский сад, 3-Начальная школа, 4-Средняя школа, 5-Старшая школа, 6-Факультативные занятия, 7-Школьный календарь
    if (index === 1 && dropdownLinks.length >= 8) {
      // Для узбекской версии используем специальный ключ перевода
      const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
      if (isUzbekistan && t.nav_program_cambridge_uz) {
        dropdownLinks[0].textContent = t.nav_program_cambridge_uz;
      } else {
        dropdownLinks[0].textContent = t.nav_program_cambridge;
      }
      if (isUzbekistan && t.nav_program_russian_uz) {
        dropdownLinks[1].textContent = t.nav_program_russian_uz;
      } else {
        dropdownLinks[1].textContent = t.nav_program_russian;
      }
      // Пункт "Преимущества" удален, индексы сдвинуты
      dropdownLinks[2].textContent = t.nav_program_kindergarten;
      dropdownLinks[3].textContent = t.nav_program_primary;
      dropdownLinks[4].textContent = t.nav_program_middle;
      dropdownLinks[5].textContent = t.nav_program_high;
      dropdownLinks[6].textContent = t.nav_program_elective;
      dropdownLinks[7].textContent = t.nav_program_calendar;
    }
    
    // Подменю "Преподаватели" (индекс 2)
    if (index === 2 && dropdownLinks.length >= 5) {
      dropdownLinks[0].textContent = t.nav_teachers_all;
      dropdownLinks[1].textContent = t.nav_teachers_kindergarten;
      dropdownLinks[2].textContent = t.nav_teachers_primary;
      dropdownLinks[3].textContent = t.nav_teachers_middle;
      dropdownLinks[4].textContent = t.nav_teachers_admin;
    }
    
    // Подменю "Поступление" (индекс 3)
    if (index === 3 && dropdownLinks.length >= 5) {
      dropdownLinks[0].textContent = t.nav_admission_process;
      dropdownLinks[1].textContent = t.nav_admission_apply;
      dropdownLinks[2].textContent = t.nav_admission_testing;
      dropdownLinks[3].textContent = t.nav_admission_documents;
      dropdownLinks[4].textContent = t.nav_admission_open_days;
    }
    
    // Подменю "Стоимость" (индекс 4)
    if (index === 4 && dropdownLinks.length >= 6) {
      const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
      const dropdownMenu = menuItem.querySelector('.dropdown-menu');
      const menuItems = Array.from(dropdownMenu.querySelectorAll('li'));

      setNavFeeDropdownTextsByHref(dropdownMenu, t);

      const findTashkentFeeLi = () => menuItems.find((item) => {
        const link = item.querySelector('a');
        return link && (link.getAttribute('href') || '').includes('campuses/tashkent/tuition-fees');
      });

      // Для узбекской версии перемещаем Ташкент на вторую позицию (после "Стоимость обучения")
      if (isUzbekistan && menuItems.length >= 6) {
        const tashkentItem = findTashkentFeeLi();
        const firstItem = menuItems[0];
        if (tashkentItem && firstItem && tashkentItem !== firstItem) {
          dropdownMenu.insertBefore(tashkentItem, firstItem.nextSibling);
        }
      } else if (!isUzbekistan && menuItems.length >= 6) {
        const tashkentItem = findTashkentFeeLi();
        if (tashkentItem && tashkentItem !== menuItems[menuItems.length - 1]) {
          dropdownMenu.appendChild(tashkentItem);
        }
      }
    }
    
    // Подменю "Кампусы" (индекс 5)
    if (index === 5 && dropdownLinks.length >= 6) {
      const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
      const dropdownMenu = menuItem.querySelector('.dropdown-menu');
      const menuItems = Array.from(dropdownMenu.querySelectorAll('li'));

      setNavCampusesDropdownTextsByHref(dropdownMenu, t);

      const findTashkentCampusLi = () => menuItems.find((item) => {
        const link = item.querySelector('a');
        return link && (link.getAttribute('href') || '').includes('/campuses/tashkent/');
      });

      // Для узбекской версии перемещаем Ташкент на вторую позицию (после "Все")
      if (isUzbekistan && menuItems.length >= 6) {
        const tashkentItem = findTashkentCampusLi();
        const firstItem = menuItems[0];
        if (tashkentItem && firstItem && tashkentItem !== firstItem) {
          dropdownMenu.insertBefore(tashkentItem, firstItem.nextSibling);
        }
      } else if (!isUzbekistan && menuItems.length >= 6) {
        const tashkentItem = findTashkentCampusLi();
        if (tashkentItem && tashkentItem !== menuItems[menuItems.length - 1]) {
          dropdownMenu.appendChild(tashkentItem);
        }
      }
    }
    
    // Подменю "Youngzine Media" (индекс 6)
    if (index === 6 && dropdownLinks.length >= 4) {
      dropdownLinks[0].textContent = t.nav_media_all;
      dropdownLinks[1].textContent = t.nav_media_journal;
      dropdownLinks[2].textContent = t.nav_media_articles;
      dropdownLinks[3].textContent = t.nav_media_news;
    }
  });

  // Шапка
  const applyBtn = document.querySelector('.apply');
  if (applyBtn) {
    applyBtn.textContent = t.apply;
  }

  const searchInput = document.getElementById('searchInput');
  if (searchInput) searchInput.placeholder = t.search_placeholder;

  const menuText = document.querySelector('.menu-text');
  if (menuText) menuText.textContent = t.menu_text;

  // Hero секция
  // Перевод about_content - ТОЛЬКО первый слайд
  // Остальные слайды (index >= 1) берут текст из CMS и НЕ ДОЛЖНЫ перезаписываться
  const heroSlides = document.querySelectorAll('.hero-slide');
  heroSlides.forEach((slide, index) => {
    // ТОЛЬКО первый слайд (index === 0) использует статичные переводы
    // Все остальные слайды (index >= 1) НЕ ТРОГАЕМ - текст уже из CMS
    if (index !== 0) {
      return; // Пропускаем все слайды кроме первого
    }
    
    const aboutContent = slide.querySelector('.about_content');
    if (!aboutContent) return;
    
    const promoText = aboutContent.querySelector('.promo_text');
    const promoText2 = aboutContent.querySelector('.promo_text2');
    
    // Первый слайд - статический текст из переводов (textContent — без HTML, избегаем h2)
    if (promoText) {
      // Если пришёл h2 из CMS/кэша — заменяем на p до обновления контента
      if (promoText.tagName === 'H2' || promoText.tagName === 'H3') {
        const p = document.createElement('p');
        p.className = promoText.className;
        if (promoText.dataset.originalText) p.dataset.originalText = promoText.dataset.originalText;
        p.textContent = promoText.textContent;
        promoText.replaceWith(p);
        promoText = p; // для последующего updatePromoTextDesktop
      }
      promoText.textContent = t.hero_title;
      promoText.dataset.originalText = t.hero_title;
      if (typeof window.updatePromoTextDesktop === 'function') {
        window.updatePromoTextDesktop(promoText, t.hero_title);
      }
    }
      if (promoText2) {
        // Определяем регион для выбора правильного текста
        const saved = getCookie(COOKIE_NAME);
        let currentRegion = 'Россия';
        if (saved) {
          try {
            const regionData = JSON.parse(saved);
            currentRegion = regionData.name;
          } catch (e) {
            // Если не удалось распарсить, используем значение по умолчанию
          }
        }
        
        // Для Узбекистана: "2-18", для России: "2.5-18"
        const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
        let subtitleText = isUzbekistan ? (t.hero_subtitle_uzbekistan || t.hero_subtitle) : t.hero_subtitle;
        
        promoText2.innerHTML = subtitleText;
        promoText2.dataset.originalText = subtitleText;
        if (typeof window.updatePromoText2 === 'function') {
          window.updatePromoText2(promoText2, subtitleText);
      }
    }
  });

  // Кнопки
  const btnTexts = document.querySelectorAll('.btn-text');
  if (btnTexts.length >= 4) {
    btnTexts[0].innerHTML = t.btn_trial;
    btnTexts[1].innerHTML = t.btn_open_days;
    btnTexts[2].innerHTML = t.btn_camps;
    btnTexts[3].innerHTML = t.btn_cost;
  }
  
  if (typeof updateBtnTextsForMobile === 'undefined') {
    window['updateBtnTextsForMobile'] = function () {
      // Функция отключена - br теги должны работать при 768px
      return;
    }
  }
  
  // Заменяем <br /> на пробелы в btn-text при ширине ≤768px
  updateBtnTextsForMobile();

  // Block2
  const infoTitle = document.querySelector('.info_title');
  if (infoTitle) infoTitle.textContent = t.block2_title;

  const infoText = document.querySelector('.info_text');
  if (infoText) infoText.textContent = t.block2_greeting;

  // Обновляем единый текст для всех устройств
  // Для Узбекистана заменяем "от 2,5 до 18 лет" на "от 2 до 18 лет"
  const isUzbekistanInfoText2 = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
  
  const infoText2Main = document.getElementById('block2_text_main');
  if (infoText2Main && t.block2_text) {
    let mainText = t.block2_text;
    if (isUzbekistanInfoText2) {
      mainText = mainText.replace(/от 2,5 до 18 лет/g, 'от 2 до 18 лет');
      mainText = mainText.replace(/от 2\.5 до 18 лет/g, 'от 2 до 18 лет');
      mainText = mainText.replace(/2,5-18/g, '2-18');
      mainText = mainText.replace(/2\.5-18/g, '2-18');
      mainText = mainText.replace(/aged 2\.5 to 18/g, 'aged 2 to 18');
      mainText = mainText.replace(/aged 2,5 to 18/g, 'aged 2 to 18');
    }
    infoText2Main.textContent = mainText;
  }

  const infoSchool = document.querySelector('.info_school');
  if (infoSchool) infoSchool.textContent = t.block2_offers;

  const infoLinks = document.querySelectorAll('.info_school_2 .link');
  if (infoLinks.length >= 3) {
    infoLinks[0].innerHTML = t.block2_item1;
    infoLinks[1].innerHTML = t.block2_item2;
    infoLinks[2].innerHTML = t.block2_item3;
  }

  // Обновляем тексты карусели для мобильной версии
  const carouselTexts = document.querySelectorAll('.info_school_2_carousel .info_school_2_text');
  if (carouselTexts.length >= 3) {
    carouselTexts[0].textContent = t.block2_carousel_item1;
    // Определяем регион для выбора правильного текста для второго элемента карусели
    const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    carouselTexts[1].textContent = isUzbekistan ? (t.block2_carousel_item2_uzbekistan || t.block2_carousel_item2) : t.block2_carousel_item2;
    carouselTexts[2].textContent = t.block2_carousel_item3;
  }

  // Обновляем desktop и mobile версии отдельно
  // Обновляем единый текст для всех устройств
  const infoMainDesktop = document.querySelector('.info_main_desktop');
  if (infoMainDesktop && t.block2_main) infoMainDesktop.innerHTML = t.block2_main;

  const infoMainMobile = document.querySelector('.info_main_mobile');
  if (infoMainMobile && t.block2_main) infoMainMobile.innerHTML = t.block2_main;

  const infoMain = document.querySelector('.info_main:not(.info_main_desktop):not(.info_main_mobile)');
  if (infoMain && t.block2_main) infoMain.innerHTML = t.block2_main;

  const infoMain2 = document.querySelector('.info_main_2');
  if (infoMain2) infoMain2.textContent = t.block2_invitation;

  // Block2 - обновляем имя и должность директора
  const curCountryEl = document.getElementById('curCountry');
  const isUzbekistanRegion = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
  
  const infoJessica = document.querySelector('.info_jessica');
  if (infoJessica) {
    if (isUzbekistanRegion) {
      infoJessica.textContent = t.block2_jessica_uzbekistan || 'Рунар Салимуллин';
    } else {
      infoJessica.textContent = t.block2_jessica;
    }
  }

  const infoJessica2 = document.querySelector('.info_jessica_2');
  if (infoJessica2) {
    if (isUzbekistanRegion) {
      infoJessica2.textContent = t.block2_director_uzbekistan || 'Директор кампуса Ташкент';
    } else {
      infoJessica2.textContent = t.block2_director;
    }
  }
  
  // Обновляем фото только для России (для Узбекистана устанавливается в applyRegion)
  const infoJessicaImg = document.querySelector('.info_img_jessica');
  if (infoJessicaImg && !isUzbekistanRegion) {
    infoJessicaImg.src = landingAssetPath('/landing_2025/src/img/JS.webp');
    infoJessicaImg.alt = 'js';
  }

  // Block3 - Формы. Определяем тип по id формы: request_form_1=экскурсия, request_form_2=тестирование,
  // request_form_trial_day=пробный день, request_form_3=консультация, request_form_4=вопросы
  const formTxts = document.querySelectorAll('.form_txt');
  formTxts.forEach((formTxt) => {
    const parent = formTxt.closest('.form_hover, .form_hover_step2');
    if (!parent) return;

    const form = formTxt.closest('form');
    const isBlock20 = parent.closest('#block20');
    if (isBlock20) return; // block20 (newsletter) — свой текст

    const isStep2 = parent.classList.contains('form_hover_step2');
    let title = null;

    if (isStep2) {
      const hiddenInput = parent.querySelector('input[name="form_name"]');
      if (hiddenInput) {
        const formName = hiddenInput.value;
        if (formName.includes('пробный') || formName.includes('trial')) title = t.form_trial_title;
        else if (formName.includes('экскурсию') || formName.includes('tour')) title = t.form_tour_title;
        else if (formName.includes('тестирование') || formName.includes('testing') || formName.includes('assessment')) title = t.form_testing_title;
        else if (formName.includes('консультацию') || formName.includes('consultation')) title = t.form_consultation_title;
        else if (formName.includes('вопрос') || formName.includes('question')) title = t.block18_title;
      }
    } else if (form) {
      // Определяем по id формы (надёжно работает на главной и на странице детского сада)
      const formId = form.id || '';
      if (formId === 'request_form_trial_day') title = t.form_trial_title;
      else if (formId === 'request_form_2') title = t.form_testing_title;
      else if (formId === 'request_form_3') title = t.form_consultation_title;
      else if (formId === 'request_form_1' || formId === 'request_form_4') title = formId === 'request_form_4' ? t.block18_title : t.form_tour_title;
      else {
        // Fallback: по родительской секции
        if (parent.closest('#trial-day-form')) title = t.form_trial_title;
        else if (parent.closest('#testing-form') || parent.closest('#block11')) title = t.form_testing_title;
        else if (parent.closest('#block16')) title = t.form_consultation_title;
        else if (parent.closest('#block3') || parent.closest('#tour-form')) title = t.form_tour_title;
        else title = t.form_tour_title;
      }
    } else {
      title = t.form_tour_title;
    }

    if (title) formTxt.textContent = title;
  });

  const phoneLabels = document.querySelectorAll('label[for="phone"], label[for*="phone"]');
  phoneLabels.forEach(label => {
    const required = label.querySelector('.required');
    label.innerHTML = t.form_phone + (required ? ' <span class="required">*</span>' : '');
  });

  const phoneInputs = document.querySelectorAll('input[type="tel"]');
  phoneInputs.forEach(input => {
    // Пропускаем поля с intl-tel-input (phone, phone2, phone3, phone4)
    // Они управляют placeholder самостоятельно на основе выбранной страны
    const hasIntlTelInput = input._iti ||
                             input.id === 'phone' ||
                             input.id === 'phone2' ||
                             input.id === 'phone3' ||
                             input.id === 'phone4';
    
    if (!hasIntlTelInput && input.placeholder) {
      input.placeholder = t.form_phone_placeholder;
    }
  });

  const phoneModalHeaders = document.querySelectorAll('.phone_modal_header');
  phoneModalHeaders.forEach(header => {
    header.textContent = t.form_select_country;
  });

  const submitBtns = document.querySelectorAll('#submitBtn1, #submitBtn2, #submitBtn3, #submitBtn_trial_day');
  submitBtns.forEach(btn => {
    btn.textContent = t.form_next;
  });

  const submitStep2Btns = document.querySelectorAll('#submitStep2_1, #submitStep2_2, #submitStep2_3, #submitStep2_trial_day');
  submitStep2Btns.forEach(btn => {
    btn.textContent = t.form_submit;
  });

  const altTexts = document.querySelectorAll('.alt_text, .form_step2_alt_text');
  altTexts.forEach(alt => {
    // Пропускаем block20_consent - у него свой текст
    const isBlock20Consent = alt.classList.contains('block20_consent');
    if (isBlock20Consent) {
      return;
    }
    
    // Определяем регион для выбора правильного номера телефона
    // Используем currentRegion, который уже определен в начале функции
    const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    
    // Для Узбекистана - номер +998 (71) 209 66 69, для России - 8 800 551 43 96
    const phoneNumber = isUzbekistan ? '+998 (71) 209 66 69' : '8 800 551 43 96';
    const phoneHref = isUzbekistan ? 'tel:+998712096669' : 'tel:88005514396';
    
    alt.innerHTML = t.form_alt_text + ' <a href="' + phoneHref + '">' + phoneNumber + '</a>';
  });

  // Form_step2 - переводы лейблов
  const formStep2Labels = document.querySelectorAll('.form_step2_input_wrapper label');
  formStep2Labels.forEach(label => {
    const forAttr = label.getAttribute('for');
    if (forAttr) {
      // Проверяем, есть ли звездочка ДО изменения innerHTML
      const hasRequired = label.querySelector('.required') !== null;
      const requiredHtml = hasRequired ? ' <span class="required">*</span>' : '';
      
      if (forAttr.includes('parent_name')) {
        label.innerHTML = t.form_parent_name + requiredHtml;
      } else if (forAttr.includes('email')) {
        label.innerHTML = t.form_email + requiredHtml;
      } else if (forAttr.includes('child_name')) {
        label.innerHTML = t.form_child_name + requiredHtml;
      } else if (forAttr.includes('birth_date')) {
        label.innerHTML = t.form_birth_date + requiredHtml;
      } else if (forAttr.includes('campus')) {
        label.innerHTML = t.form_campus + requiredHtml;
      } else if (forAttr.includes('phone_step2')) {
        label.innerHTML = t.form_phone + requiredHtml;
      }
    }
  });

  // Form_step2 - переводы placeholder для birth_date
  const birthDateInputs = document.querySelectorAll('input[name="birth_date"]');
  birthDateInputs.forEach(input => {
    if (input.placeholder) {
      input.placeholder = lang === 'ru' ? 'xx.xx.xxxx' : 'xx.xx.xxxx';
    }
  });

  // Form_step2 - переводы placeholder для child_name
  const childNameInputs = document.querySelectorAll('input[name="child_name"]');
  childNameInputs.forEach(input => {
    if (input.placeholder && t.form_child_name_placeholder) {
      input.placeholder = t.form_child_name_placeholder;
    }
  });

  // Form_step2 - переводы placeholder для campus select
  const campusSelectsPlaceholder = document.querySelectorAll('select[name="campus"]');
  campusSelectsPlaceholder.forEach(select => {
    const firstOption = select.querySelector('option[value=""]');
    if (firstOption && t.campus_select_placeholder) {
      firstOption.textContent = t.campus_select_placeholder;
    }
  });

  // Block4
  const campusesTitle = document.querySelector('.campuses');
  if (campusesTitle) campusesTitle.textContent = t.block4_title;

  const campusesSubtitle = document.querySelector('.subtitle');
  if (campusesSubtitle) campusesSubtitle.textContent = t.block4_subtitle;

  // Обновляем названия кампусов из CMS, а не из статичных переводов
  // НЕ перезаписываем данные из CMS - они уже правильные в HTML
  const campusLabels = document.querySelectorAll('.campus_label');
  const campusCards = document.querySelectorAll('.campus_card');
  
  campusCards.forEach((card, index) => {
    const label = campusLabels[index];
    if (!label) return;
    
    // Получаем slug кампуса из data-атрибута
    const campusSlug = card.getAttribute('data-campus_slug') || label.getAttribute('data-campus-slug');
    const campusId = card.getAttribute('data-campus_id') || label.getAttribute('data-campus-id');
    
    // Используем данные из CMS, если доступны
    if (typeof window.campusesFromCMS !== 'undefined' && Array.isArray(window.campusesFromCMS)) {
      const campusFromCMS = window.campusesFromCMS.find(c =>
        (campusSlug && c.slug === campusSlug) ||
        (campusId && c.id.toString() === campusId)
      );
      
      if (campusFromCMS) {
        const campusName = lang === 'en' ? campusFromCMS.name_en : campusFromCMS.name_ru;
        if (campusName) {
          // Форматируем название так же, как в шаблоне (разбиваем по пробелам)
          const formattedName = campusName.split(/\s/).join('<br>');
          // Обновляем только если текст отличается (чтобы не перезаписывать правильные данные)
          if (label.innerHTML.trim() !== formattedName) {
            label.innerHTML = formattedName;
          }
          return;
        }
      }
    }
    
    // Также проверяем data-атрибуты карточки для получения названия
    const campusNameRu = card.getAttribute('data-campus_name_ru');
    const campusNameEn = card.getAttribute('data-campus_name_en');
    if (campusNameRu || campusNameEn) {
      const campusName = lang === 'en' ? campusNameEn : campusNameRu;
      if (campusName) {
        const formattedName = campusName.split(/\s/).join('<br>');
        if (label.innerHTML.trim() !== formattedName) {
          label.innerHTML = formattedName;
        }
        return;
      }
    }
    
    // Fallback на статичные переводы, если данных из CMS нет
    // НО НЕ перезаписываем, если label уже содержит данные из CMS (проверяем по data-атрибутам)
    const currentText = label.innerHTML.trim();
    
    // Если у label есть data-атрибуты с данными из CMS, НЕ перезаписываем
    if (label.getAttribute('data-campus-slug') || label.getAttribute('data-campus-id')) {
      // Данные из CMS уже есть, не трогаем
      return;
    }
    
    const campusTranslations = [t.campus_skolkovo, t.campus_moscow, t.campus_gorki, t.campus_spb, t.campus_tashkent];
    if (index < campusTranslations.length) {
      // Обновляем только если текущий текст пустой или соответствует старому переводу
      const translationText = campusTranslations[index];
      if (!currentText || currentText === '' || currentText === translationText) {
        label.innerHTML = translationText;
      }
    }
  });
  
  // Защита картинок: не позволяем перезаписывать src у картинок из CMS
  const campusCardImages = document.querySelectorAll('.campus_card img');
  campusCardImages.forEach((img) => {
    const campusSlug = img.getAttribute('data-campus_slug');
    const campusId = img.getAttribute('data-campus_id');
    const originalSrc = img.getAttribute('src');
    
    // Если есть data-атрибут с правильной картинкой из CMS, защищаем её
    if (campusSlug || campusId) {
      // Сохраняем оригинальный src из data-атрибута карточки, если доступен
      const card = img.closest('.campus_card');
      if (card) {
        const dataPicture = card.getAttribute('data-campus_picture');
        if (dataPicture && dataPicture !== originalSrc) {
          // Восстанавливаем правильную картинку из data-атрибута
          img.src = dataPicture;
          img.dataset.originalSrc = dataPicture;
          return;
        }
      }
      
      // Сохраняем оригинальный src, если он еще не сохранен
      if (!img.dataset.originalSrc && originalSrc) {
        img.dataset.originalSrc = originalSrc;
      }
      
      // Восстанавливаем оригинальный src, если он был изменен
      if (img.dataset.originalSrc && img.src !== img.dataset.originalSrc) {
        img.src = img.dataset.originalSrc;
      }
    }
  });

  const mapText = document.querySelector('.map_text');
  if (mapText) mapText.textContent = t.map_view;

  // Block5
  const campusPhoto = document.querySelector('.campus_photo');
  if (campusPhoto) campusPhoto.textContent = t.block5_title;

  // Block5 - campus_tabs кнопки
  const campusTabs = document.querySelectorAll('.campus_btn');
  const campusTabTranslations = {
    'tgn': t.campus_tab_territory,
    'int': t.campus_tab_interior,
    'lessons': t.campus_tab_lessons,
    'events': t.campus_tab_events
  };
  campusTabs.forEach(btn => {
    const dataCampus = btn.getAttribute('data-campus');
    if (dataCampus && campusTabTranslations[dataCampus]) {
      btn.textContent = campusTabTranslations[dataCampus];
    }
  });

  // Выпадающий список кампусов в Block5
  const selectedCampus = document.getElementById('selectedCampus');
  if (selectedCampus) {
    // Используем переводы из объекта translations
    const campusNames = {
      'skolkovo': t.campus_name_skolkovo,
      'moscow': t.campus_name_moscow,
      'gorki': t.campus_name_gorki,
      'spb': t.campus_name_spb,
      'tashkent': t.campus_name_tashkent
    };
    
    // Маппинг русских названий для определения текущего кампуса
    const campusNamesRu = {
      'Сколково': 'skolkovo',
      'Москва': 'moscow',
      'Горки': 'gorki',
      'Санкт-Петербург': 'spb',
      'Ташкент': 'tashkent'
    };
    
    // Маппинг английских названий для определения текущего кампуса
    const campusNamesEn = {
      'Skolkovo': 'skolkovo',
      'Moscow': 'moscow',
      'Gorki': 'gorki',
      'St. Petersburg': 'spb',
      'Saint Petersburg': 'spb',
      'Tashkent': 'tashkent'
    };
    
    // Если уже есть значение, переводим его
    const currentText = selectedCampus.textContent.trim();
    if (currentText) {
      // Определяем по тексту какой кампус выбран
      let campusKey = null;
      
      // Сначала проверяем русские названия
      for (const [name, key] of Object.entries(campusNamesRu)) {
        if (currentText === name || currentText.includes(name)) {
          campusKey = key;
          break;
        }
      }
      
      // Если не нашли, проверяем английские названия
      if (!campusKey) {
        for (const [name, key] of Object.entries(campusNamesEn)) {
          if (currentText === name || currentText.includes(name)) {
            campusKey = key;
            break;
          }
        }
      }
      
      // Если нашли кампус, обновляем текст
      if (campusKey && campusNames[campusKey]) {
        selectedCampus.textContent = campusNames[campusKey];
      }
    }
  }

  // Переводим опции в выпадающем списке кампусов
  const campusOptions = document.querySelectorAll('.campus_option');
  const campusOptionMap = {
    'skolkovo': t.campus_name_skolkovo,
    'moscow': t.campus_name_moscow,
    'gorki': t.campus_name_gorki,
    'spb': t.campus_name_spb,
    'tashkent': t.campus_name_tashkent
  };
  
  campusOptions.forEach((opt) => {
    const dataCampus = opt.getAttribute('data-campus');
    if (dataCampus && campusOptionMap[dataCampus]) {
      opt.textContent = campusOptionMap[dataCampus];
    }
  });

  // Block6 - полные переводы
  const block6Container = document.querySelector('.container_advange') || document.querySelector('#advantages');
  const block6Title = block6Container ? block6Container.querySelector('.advage') : document.querySelector('.advage');
  if (block6Title) block6Title.textContent = t.block6_title;

  // Получаем только реальные карточки (исключаем клоны, созданные слайдером)
  // Ищем внутри контейнера block6, если он существует
  const advantagesGrid = block6Container ? block6Container.querySelector('.advantages_grid') : null;
  const allAdvantageCards = advantagesGrid
    ? advantagesGrid.querySelectorAll('.advantage_card')
    : document.querySelectorAll('.advantage_card');
  const advantageCards = Array.from(allAdvantageCards).filter(card => !card.classList.contains('advantage-card-clone'));
  // Порядок карточек: 0-Две программы, 1-Международная среда, 2-Питание, 3-Безопасность, 4-Кружки, 5-Наши выпускники, 6-Soft skills
  // Порядок изменен: Питание теперь на позиции 2, Безопасность на позиции 3
  if (advantageCards.length >= 7) {
    // Карточка 0: Две программы
    const card0 = advantageCards[0];
    const title0 = card0.querySelector('.progamms');
    if (title0) title0.textContent = t.block6_programs_title;
    const p0 = card0.querySelector('p');
    if (p0) {
      // Определяем регион для выбора правильного текста
      const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
      const programsText = isUzbekistan ? (t.block6_programs_text_uzbekistan || t.block6_programs_text) : t.block6_programs_text;
      p0.innerHTML = programsText;
    }
    const items0 = card0.querySelectorAll('li');
    if (items0.length >= 3) {
      items0[0].textContent = t.block6_programs_item1;
      items0[1].textContent = t.block6_programs_item2;
      items0[2].textContent = t.block6_programs_item3;
    }

    // Карточка 1: Международная среда
    const card1 = advantageCards[1];
    const title1 = card1.querySelector('.progamms');
    if (title1) title1.textContent = t.block6_international_title;
    const items1 = card1.querySelectorAll('li');
    if (items1.length >= 4) {
      items1[0].textContent = t.block6_international_item1;
      items1[1].textContent = t.block6_international_item2;
      items1[2].textContent = t.block6_international_item3;
      items1[3].textContent = t.block6_international_item4;
    }

    // Карточка 2: Питание (теперь на позиции 2)
    const card2 = advantageCards[2];
    const title2 = card2.querySelector('.progamms');
    if (title2) title2.textContent = t.block6_meals_title;
    const items2 = card2.querySelectorAll('li');
    if (items2.length >= 2) {
      items2[0].textContent = t.block6_meals_item1;
      items2[1].textContent = t.block6_meals_item2;
      // Для английского языка добавляем третий пункт, если он есть
      if (items2.length >= 3 && t.block6_meals_item3) {
        items2[2].textContent = t.block6_meals_item3;
        items2[2].style.display = '';
      } else if (items2.length >= 3) {
        // Скрываем третий пункт для языков, где его нет
        items2[2].style.display = 'none';
      }
    }

    // Карточка 3: Безопасность (теперь на позиции 3)
    const card3 = advantageCards[3];
    const title3 = card3.querySelector('.progamms');
    if (title3) title3.textContent = t.block6_safety_title;
    const p3 = card3.querySelector('p');
    if (p3) p3.textContent = t.block6_safety_text;
    const items3 = card3.querySelectorAll('li');
    if (items3.length >= 2) {
      items3[0].textContent = t.block6_safety_item1;
      items3[1].textContent = t.block6_safety_item2;
    }

    // Карточка 4: Кружки
    const card4 = advantageCards[4];
    const title4 = card4.querySelector('.progamms');
    if (title4) title4.textContent = t.block6_clubs_title;
    const p4 = card4.querySelector('p');
    if (p4) {
      const isUzbekistanClubs = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
      p4.innerHTML = isUzbekistanClubs ? (t.block6_clubs_text_uzbekistan || t.block6_clubs_text) : t.block6_clubs_text;
    }
    const items4 = card4.querySelectorAll('li');
    if (items4.length >= 5) {
      items4[0].textContent = t.block6_clubs_item1;
      items4[1].textContent = t.block6_clubs_item2;
      items4[2].textContent = t.block6_clubs_item3;
      items4[3].textContent = t.block6_clubs_item4;
      items4[4].textContent = t.block6_clubs_item5;
    }

    // Карточка 5: Наши выпускники
    const card5 = advantageCards[5];
    const title5 = card5.querySelector('.progamms');
    if (title5) title5.textContent = t.block6_graduates;
    const items5 = card5.querySelectorAll('li');
    if (items5.length >= 2) {
      items5[0].textContent = t.block6_graduates_item1;
      items5[1].textContent = t.block6_graduates_item2;
    }

    // Карточка 6: Soft skills
    const card6 = advantageCards[6];
    const title6 = card6.querySelector('.progamms');
    if (title6) title6.textContent = t.block6_soft_skills;
    const p6 = card6.querySelector('p');
    if (p6) p6.innerHTML = t.block6_soft_skills_text;
    const items6 = card6.querySelectorAll('li');
    if (items6.length >= 4) {
      items6[0].textContent = t.block6_communication;
      items6[1].textContent = t.block6_teamwork;
      items6[2].textContent = t.block6_critical;
      items6[3].textContent = t.block6_creativity;
    }
  }

  // Block7
  const formBr = document.querySelector('.form_br');
  if (formBr) formBr.textContent = t.block7_title;

  const formLabels = document.querySelectorAll('.download_form label');
  // Порядок: 0-Имя, 1-Телефон, 2-E-mail, 3-Кампус
  formLabels.forEach((label, index) => {
    const required = label.querySelector('.request');
    if (index === 0) {
      label.innerHTML = t.block7_name;
    } else if (index === 1) {
      label.innerHTML = t.block7_phone + (required ? ' <span class="request">*</span>' : '');
    } else if (index === 2) {
      label.innerHTML = t.block7_email + (required ? ' <span class="request">*</span>' : '');
    } else if (index === 3) {
      label.innerHTML = t.block7_campus + (required ? ' <span class="request">*</span>' : '');
    }
  });

  // Обновляем плейсхолдеры в форме block7
  const nameInput = document.getElementById('name');
  if (nameInput && t.block7_name_placeholder) {
    nameInput.placeholder = t.block7_name_placeholder;
  }
  
  const emailInput = document.getElementById('email');
  if (emailInput && t.block7_email_placeholder) {
    emailInput.placeholder = t.block7_email_placeholder;
  }
  
  // Плейсхолдер для телефона обновляется через updateBlock7PhoneLimits

  const downloadBtn = document.querySelector('.download_btn');
  if (downloadBtn) {
    const img = downloadBtn.querySelector('img');
    downloadBtn.innerHTML = '';
    if (img) downloadBtn.appendChild(img);
    downloadBtn.appendChild(document.createTextNode(' ' + t.block7_download));
  }

  // Специальная обработка капчи для block7
  const antibotLabelBlock7 = document.getElementById('antibotLabelBlock7');
  if (antibotLabelBlock7 && t.antibot_question) {
    // Извлекаем числа из data-question или из текста label
    let num1 = null;
    let num2 = null;
    
    // Сначала проверяем data-question
    let dataQuestion = antibotLabelBlock7.getAttribute('data-question');
    if (dataQuestion) {
      // Улучшенное регулярное выражение для распознавания разных форматов
      // Поддерживаем: "Сколько будет 14 - 4?", "What is 14-7", "14-7", "14 минус 4" и т.д.
      // Ищем любые два числа разделенные дефисом, пробелами или словами "минус"/"minus"
      const match = dataQuestion.match(/(\d+)\s*(?:-|минус|minus)\s*(\d+)/i);
      if (match && match[1] && match[2]) {
        num1 = match[1];
        num2 = match[2];
      }
    }
    
    // Если не нашли в data-question, проверяем текст label
    if (!num1 || !num2) {
      const labelText = antibotLabelBlock7.textContent.trim();
      // Убираем звездочку и другие символы, но сохраняем числа
      const cleanText = labelText.replace(/\*/g, '').replace(/<[^>]*>/g, '').trim();
      // Извлекаем числа из текста (поддерживаем разные форматы: "What is 14-7", "Сколько будет 14 - 4", и т.д.)
      const match = cleanText.match(/(\d+)\s*(?:-|минус|minus)\s*(\d+)/i);
      if (match && match[1] && match[2]) {
        num1 = match[1];
        num2 = match[2];
      }
    }
    
    // Если нашли числа, обновляем текст
    if (num1 && num2) {
      const questionText = t.antibot_question
        .replace('{num1}', num1)
        .replace('{num2}', num2);
      
      // Обновляем data-question
      antibotLabelBlock7.setAttribute('data-question', questionText);
      
      // Сохраняем span.request
      const requestHtml = '<span class="request">*</span>';
      
      antibotLabelBlock7.innerHTML = `${questionText} ${requestHtml}`;
    }
  }

  const note = document.querySelector('.note');
  if (note) {
    const noteText = note.querySelector('.note_text');
    if (noteText) {
      noteText.textContent = t.block7_note;
      // Устанавливаем data-атрибут для мобильной версии (используется в CSS ::before)
      if (t.block7_note_mobile) {
        noteText.setAttribute('data-mobile-text', t.block7_note_mobile);
      }
    } else {
      // Если .note_text нет, создаем его и обновляем только текст
      const existingContent = Array.from(note.childNodes);
      const img = note.querySelector('.note_icon');
      note.innerHTML = '';
      const span = document.createElement('span');
      span.className = 'note_text';
      span.textContent = t.block7_note;
      // Устанавливаем data-атрибут для мобильной версии (используется в CSS ::before)
      if (t.block7_note_mobile) {
        span.setAttribute('data-mobile-text', t.block7_note_mobile);
      }
      note.appendChild(span);
      if (img) note.appendChild(img);
    }
  }

  // Block8
  const infoCisTitle = document.querySelector('.info_cis_title');
  if (infoCisTitle) infoCisTitle.textContent = t.block8_title;

  const infoP = document.querySelector('.info_p');
  if (infoP) {
    // Определяем регион для выбора правильного текста
    const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    const block8Text = isUzbekistan && t.block8_text_uzbekistan
      ? t.block8_text_uzbekistan
      : t.block8_text;
    
    if (block8Text) {
      infoP.innerHTML = block8Text;
      // Устанавливаем data-атрибут для CSS ::before (используется на десктопе)
      infoP.setAttribute('data-desktop-text', block8Text.replace(/<br\s*\/?>/gi, ' '));
    }
  }

  const cardHeaders = document.querySelectorAll('.card_header');
  const cardHeaderTranslations = [t.card_kindergarten, t.card_primary, t.card_middle, t.card_high];
  cardHeaders.forEach((header, index) => {
    if (index < cardHeaderTranslations.length) {
      header.innerHTML = cardHeaderTranslations[index];
    }
  });

  // Обновляем program_subtitle
  const programSubtitles = document.querySelectorAll('.program_subtitle');
  const programSubtitleTranslations = [t.program_subtitle_kindergarten, t.program_subtitle_primary, t.program_subtitle_middle, t.program_subtitle_high];
  programSubtitles.forEach((subtitle, index) => {
    if (index < programSubtitleTranslations.length) {
      subtitle.innerHTML = programSubtitleTranslations[index];
    }
  });

  // Обновляем program_title
  const programTitles = document.querySelectorAll('.program_title');
  const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
  
  // Используем узбекские переводы для program_title, если регион = Узбекистан
  let programTitleTranslations;
  if (isUzbekistan && t.program_title_kindergarten_uzbekistan) {
    programTitleTranslations = [
      t.program_title_kindergarten_uzbekistan,
      t.program_title_primary_uzbekistan,
      t.program_title_middle_uzbekistan,
      t.program_title_high_uzbekistan
    ];
  } else {
    programTitleTranslations = [t.program_title_kindergarten, t.program_title_primary, t.program_title_middle, t.program_title_high];
  }
  
  programTitles.forEach((title, index) => {
    if (index < programTitleTranslations.length) {
      title.innerHTML = programTitleTranslations[index];
    }
  });

  const ageBadges = document.querySelectorAll('.age_badge');
  // Для Узбекистана: первый badge "2-5 лет" (ru) или "2-5 years" (en), для России: "2.5-5 лет" (ru) или "2.5-5 years" (en)
  let firstAgeBadge;
  if (isUzbekistan) {
    firstAgeBadge = lang === 'en' ? 'Ages 2-5' : '2-5 лет';
  } else {
    firstAgeBadge = t.age_3_5;
  }
  const ageBadgeTranslations = [firstAgeBadge, t.age_5_11, t.age_11_14, t.age_14_18];
  ageBadges.forEach((badge, index) => {
    if (index < ageBadgeTranslations.length) {
      badge.textContent = ageBadgeTranslations[index];
    }
  });

  // Block10 - полные тексты
  const block10 = document.getElementById('block10');
  const accordionText = block10 ? block10.querySelector('.accordion_text') : null;
  if (accordionText) accordionText.textContent = t.block10_title;

  const accordionItems = block10 ? block10.querySelectorAll('.accordion_item') : [];
  // Если контент admission-блока уже пришел с сервера, не перезаписываем его shared JS.
  const isServerRenderedAdmission = block10 && (
    block10.hasAttribute('data-secondary-admission-accordion') ||
    (accordionItems.length >= 1 && accordionItems[0].classList.contains('admission_accordion_item'))
  );
  // Порядок: 0-Этап 1, 1-Этап 2, 2-Этап 3
  if (accordionItems.length >= 3 && !isServerRenderedAdmission) {
    // Этап 1
    const item0 = accordionItems[0];
    const info0 = item0.querySelector('.accordion_info');
    if (info0) info0.textContent = t.stage1_title;
    const content0 = item0.querySelector('.accordion_content');
    if (content0) {
      // Определяем регион для выбора правильного текста стоимости
      const saved = getCookie(COOKIE_NAME);
      let currentRegion = 'Россия';
      if (saved) {
        try {
          const regionData = JSON.parse(saved);
          currentRegion = regionData.name;
        } catch (e) {
          // Если не удалось распарсить, используем значение по умолчанию
        }
      }
      const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
      
      // Выбираем правильный текст стоимости в зависимости от региона
      let stage1Text6 = t.stage1_text6;
      if (isUzbekistan && t.stage1_text6_uzbekistan) {
        stage1Text6 = t.stage1_text6_uzbekistan;
      }
      
      content0.innerHTML = '<div class="accordion_column_left">' +
        '<p><strong>' + t.stage1_text1 + '</strong></p>' +
        '<p><span class="accordion_dash">—</span> ' + (t.stage1_text2 ? t.stage1_text2.replace('— ', '') : '') + '</p>' +
        '<p><span class="accordion_dash">—</span> ' + (t.stage1_text3 ? t.stage1_text3.replace('— ', '') : '') + '</p>' +
        '<p>' + t.stage1_text4 + '</p>' +
        '<p><strong>' + t.stage1_text5 + '</strong></p>' +
        '<p><span class="accordion_dash">—</span>  <span data-testing-fee>' + (window.testingFeeLabelFor ? window.testingFeeLabelFor(((window.getCurrentCampus && window.getCurrentCampus()) || (isUzbekistan ? 'tashkent' : 'gorki')), (localStorage.getItem('siteLanguage') || 'ru')) : (stage1Text6 ? stage1Text6.replace('—  ', '') : '')) + '</span></p>' +
        '</div>' +
        '<div class="accordion_column_right">' +
        '<p><strong>' + t.stage1_text7 + '</strong></p>' +
        '<p>' + t.stage1_text8 + '</p>' +
        '<p>' + t.stage1_text9 + '</p>' +
        '</div>';
    }

    // Этап 2
    const item1 = accordionItems[1];
    const info1 = item1.querySelector('.accordion_info');
    if (info1) info1.textContent = t.stage2_title;
    const content1 = item1.querySelector('.accordion_content');
    if (content1) {
      if (t.stage2_text1 && t.stage2_text2) {
        const parts1 = t.stage2_text1.split(':');
        const parts2 = t.stage2_text2.split(':');
        content1.innerHTML = '<p><span class="accordion_dash">—</span>  <strong>' + parts1[0] + ':</strong> ' + parts1.slice(1).join(':').trim() + '</p>' +
          '<p><span class="accordion_dash">—</span>  <strong>' + parts2[0] + ':</strong> ' + parts2.slice(1).join(':').trim() + '</p>';
      } else if (t.stage2_text1) {
        // Если есть только один текст (для английской версии)
        content1.innerHTML = '<p>' + t.stage2_text1 + '</p>';
      }
    }

    // Этап 3
    const item2 = accordionItems[2];
    const info2 = item2.querySelector('.accordion_info');
    if (info2) info2.textContent = t.stage3_title;
    const content2 = item2.querySelector('.accordion_content');
    if (content2) {
      content2.innerHTML = '<div class="accordion_column_left">' +
        '<p><strong>' + t.stage3_header1 + '</strong></p>' +
        '<p><span class="accordion_dash">—</span> ' + t.stage3_list1_1 + '</p>' +
        '<p><span class="accordion_dash">—</span> ' + t.stage3_list1_2 + '</p>' +
        '<p><span class="accordion_dash">—</span> ' + t.stage3_list1_3 + '</p>' +
        '<p><span class="accordion_dash">—</span> ' + t.stage3_list1_4 + '</p>' +
        '<p><span class="accordion_dash">—</span> ' + t.stage3_list1_5 + '</p>' +
        '<p><span class="accordion_dash">—</span> ' + t.stage3_list1_6 + '</p>' +
        '<p><span class="accordion_dash">—</span> ' + t.stage3_list1_7 + '</p>' +
        '</div>' +
        '<div class="accordion_column_right">' +
        '<p><strong>' + t.stage3_header2 + '</strong></p>' +
        '<p><span class="accordion_dash">—</span> ' + t.stage3_list2_1 + '</p>' +
        '<p><span class="accordion_dash">—</span> ' + t.stage3_list2_2 + '</p>' +
        '<p><strong>' + t.stage3_header3 + '</strong></p>' +
        '<p>' + t.stage3_text_contacts + '</p>' +
        '</div>';
    }
  }

  const footerNote = block10 ? block10.querySelector('.footer_note') : null;
  if (footerNote) footerNote.textContent = t.block10_footer;

  // Block11 - форма тестирования (обе страницы внутри блока 11)
  const formTestingTxts = document.querySelectorAll('#block11 .form_txt');
  formTestingTxts.forEach(formTxt => {
    formTxt.textContent = t.form_testing_title;
  });

  // Block12
  const block12Title = document.querySelector('.block12_title');
  if (block12Title) block12Title.textContent = t.block12_title;

  // Block12 - новая структура для 769px+
  const block12TextInfoLeft = document.querySelector('.block12_text_info_left');
  if (block12TextInfoLeft) {
    const leftStrong = block12TextInfoLeft.querySelector('strong');
    if (leftStrong) leftStrong.textContent = t.block12_info_header1;
    const leftParagraphs = block12TextInfoLeft.querySelectorAll('p:not(:first-child)');
    if (leftParagraphs.length >= 1) leftParagraphs[0].innerHTML = '<span class="block12_text_dash">—</span> ' + t.block12_info_list1_1;
    if (leftParagraphs.length >= 2) leftParagraphs[1].innerHTML = '<span class="block12_text_dash">—</span> ' + t.block12_info_list1_2;
    if (leftParagraphs.length >= 3) leftParagraphs[2].innerHTML = '<span class="block12_text_dash">—</span> ' + t.block12_info_list1_3;
  }

  const block12TextInfoRight = document.querySelector('.block12_text_info_right');
  if (block12TextInfoRight) {
    const rightStrong = block12TextInfoRight.querySelector('strong');
    if (rightStrong) rightStrong.textContent = t.block12_info_header2;
    const rightParagraphs = block12TextInfoRight.querySelectorAll('p:not(:first-child)');
    if (rightParagraphs.length >= 1) rightParagraphs[0].innerHTML = '<span class="block12_text_dash">—</span> ' + t.block12_info_list2_1;
    if (rightParagraphs.length >= 2) rightParagraphs[1].innerHTML = '<span class="block12_text_dash">—</span> ' + t.block12_info_list2_2;
    if (rightParagraphs.length >= 3) rightParagraphs[2].innerHTML = '<span class="block12_text_dash">—</span> ' + t.block12_info_list2_3;
  }

  // Block12 - обновляем изображение кампуса (уже обновляется через syncCampusSelection)
  const block12TextCampusName = document.getElementById('block12TextCampusName');
  if (block12TextCampusName) {
    const block12SelectedCampus = document.getElementById('block12SelectedCampus');
    if (block12SelectedCampus) {
      // Используем тот же текст, что и в block12SelectedCampus
      const campusId = Array.from(document.querySelectorAll('.block12_campus_btn.active')).map(btn => btn.getAttribute('data-campus'))[0] || 'spb';
      const campusNames = {
        'skolkovo': t.campus_name_skolkovo,
        'moscow': t.campus_name_moscow,
        'gorki': t.campus_name_gorki,
        'spb': t.campus_name_spb,
        'tashkent': t.campus_name_tashkent
      };
      if (campusNames[campusId]) {
        const campusName = campusNames[campusId].replace(/<br\s*\/?>/gi, ' ').trim();
        block12TextCampusName.textContent = lang === 'en' ? `Campus ${campusName}` : `Кампус ${campusName}`;
      }
    }
  }

  const block12Info = document.querySelector('.block12_info');
  if (block12Info) {
    // При 768px и меньше используем новый формат, при 769px+ - старый
    if (window.innerWidth <= 768) {
      block12Info.innerHTML = '<p><strong>' + t.block12_info_header1 + '</strong></p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list1_1 + '</p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list1_2 + '</p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list1_3 + '</p>' +
        '<p style="margin-bottom: 24px;"></p>' +
        '<p><strong>' + t.block12_info_header2 + '</strong></p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list2_1 + '</p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list2_2 + '</p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list2_3 + '</p>';
    } else {
      block12Info.textContent = t.block12_info;
    }
  }
  
  // Кнопки категорий в Block12
  const block12CategoryBtns = document.querySelectorAll('.block12_category_btn');
  block12CategoryBtns.forEach(btn => {
    const dataCategory = btn.getAttribute('data-category');
    if (dataCategory === 'kindergarten') {
      btn.textContent = t.block12_category_kindergarten;
    } else if (dataCategory === 'school') {
      btn.textContent = t.block12_category_school;
    }
  });


  const block12CampusBtns = document.querySelectorAll('.block12_campus_btn');
  const block12CampusTranslations = {
    'skolkovo': t.block12_campus_skolkovo,
    'moscow': t.block12_campus_moscow,
    'gorki': t.block12_campus_gorki,
    'spb': t.block12_campus_spb,
    'tashkent': t.block12_campus_tashkent
  };
  block12CampusBtns.forEach(btn => {
    const dataCampus = btn.getAttribute('data-campus');
    if (dataCampus && block12CampusTranslations[dataCampus]) {
      btn.innerHTML = block12CampusTranslations[dataCampus];
    }
  });

  // Block12: названия и подзаголовки программ (block12_price_title, block12_price_subtitle) берутся из CMS, не перезаписываем

  const block12AgeRight = document.querySelectorAll('.block12_price_age_right');
  block12AgeRight.forEach(age => {
    var val = lang === 'en' ? age.getAttribute('data-age-en') : age.getAttribute('data-age-ru');
    age.textContent = val || t.block12_years;
  });

  // Переводим все элементы block12_price_info_text (может быть несколько для разных кампусов)
  const block12PriceInfoTexts = document.querySelectorAll('.block12_price_info_text p');
  block12PriceInfoTexts.forEach(textEl => {
    textEl.innerHTML = t.block12_price_info_text;
  });
  
  // Даты действия цен: из CMS (data-date-ru / data-date-en); иначе старый раздел с жёсткими строками
  const block12DiscountDates = document.querySelectorAll('.block12_price_discount_date');
  block12DiscountDates.forEach(dateEl => {
    const ru = dateEl.getAttribute('data-date-ru');
    const en = dateEl.getAttribute('data-date-en');
    if (lang === 'en' && en) {
      dateEl.textContent = en;
      return;
    }
    if (lang === 'ru' && ru) {
      dateEl.textContent = ru;
      return;
    }
    if (!ru && !en && t) {
      const currentText = dateEl.textContent.trim();
      if (currentText === 'до 30 Июня' || currentText === 'until June 30' || currentText === 'until 30 June 2026') {
        dateEl.textContent = t.block12_price_discount_date_before;
      } else if (currentText === 'с 30 Июня' || currentText === 'from June 30' || currentText === 'from 30 June 2026') {
        dateEl.textContent = t.block12_price_discount_date_after;
      } else if (currentText === 'с 1 Июля' || currentText === 'from July 1' || currentText === 'from 1 July 2026') {
        dateEl.textContent = t.block12_price_discount_date_after_july;
      }
    }
  });

  // Переводим все кнопки "Подробнее" (может быть несколько для разных кампусов)
  const block12PriceInfoBtnReds = document.querySelectorAll('.block12_price_info_btn_red');
  block12PriceInfoBtnReds.forEach(btn => {
    btn.textContent = t.block12_price_info_btn_more;
  });

  // Переключение валют: рубли (₽) для русского, евро (€) для английского
  // Для кампуса Ташкент на английской версии цены должны быть в суммах (UZS)
  const block12PriceDiscounts = document.querySelectorAll('.block12_price_with_discount');
  const exchangeRate = 100; // Примерный курс: 1 EUR = 100 RUB
  
  // Определяем текущий выбранный кампус
  const block12SelectedCampusEl = document.getElementById('block12SelectedCampus');
  const currentCampus = block12SelectedCampusEl ? block12SelectedCampusEl.textContent.trim().toLowerCase() : '';
  const isTashkentCampus = currentCampus.includes('tashkent') || currentCampus.includes('ташкент');
  
  block12PriceDiscounts.forEach(priceEl => {
    // Проверяем, к какому кампусу относится этот элемент цены
    const priceItem = priceEl.closest('.block12_price_item');
    const priceCampus = priceItem ? priceItem.getAttribute('data-campus') : '';
    const isTashkentPrice = priceCampus === 'tashkent' || isTashkentCampus;
    
    // КРИТИЧЕСКИ ВАЖНО: для Ташкента на английской версии проверяем ТЕКУЩИЙ текст ПЕРЕД всем остальным
    if (lang === 'en' && isTashkentPrice) {
      const currentText = priceEl.textContent.trim();
    
      
      // Если текущий текст уже в UZS, НИКОГДА не трогаем его
      if (currentText.includes('UZS')) {
        // Сохраняем UZS версию в originalValue и выходим
        priceEl.dataset.originalValue = currentText;
        priceEl.dataset.tashkentProcessed = 'true';
        return; // ВАЖНО: полностью пропускаем конвертацию валют
      }
      
      // Если текущий текст в рублях или евро, это ошибка - не должны быть
      if (currentText.includes('₽') || currentText.includes('€')) {
        // Пытаемся найти "сумов" в originalValue или в HTML
        const originalValue = priceEl.dataset.originalValue || '';
        if (originalValue.includes('сумов')) {
          const sumsMatch = originalValue.match(/([\d\s]+)\s*сумов/);
          if (sumsMatch) {
            const sumsAmount = sumsMatch[1].trim();
            const uzsValue = `${sumsAmount} UZS`;
            priceEl.textContent = uzsValue;
            priceEl.dataset.originalValue = uzsValue;
            priceEl.dataset.tashkentProcessed = 'true';
            return;
          }
        }
        
        // Пытаемся найти правильное значение из block12PricesData
        try {
          const priceItem = priceEl.closest('.block12_price_item');
          if (priceItem) {
            // Получаем год и индекс элемента
            const block12SelectedYear = document.getElementById('block12SelectedYear');
            const yearText = block12SelectedYear ? block12SelectedYear.textContent.trim() : '';
            const yearMatch = yearText.match(/(\d{4}-\d{4})/);
            const year = yearMatch ? yearMatch[1] : (window.block12CurrentYear || '2025-2026');
            
            // Получаем индекс элемента среди элементов Ташкента (только видимые)
            const allTashkentItems = Array.from(document.querySelectorAll('.block12_price_item[data-campus="tashkent"]')).filter(item => {
              const style = window.getComputedStyle(item);
              return style.display !== 'none';
            });
            const itemIndex = allTashkentItems.indexOf(priceItem);
            
            // Пытаемся получить данные из block12PricesData
            if (typeof window.block12PricesData !== 'undefined' && window.block12PricesData[year] && window.block12PricesData[year].tashkent) {
              const tashkentPrices = window.block12PricesData[year].tashkent;
              if (itemIndex >= 0 && tashkentPrices[itemIndex]) {
                // Пытаемся найти цену с "сумов" в данных
                const priceData = tashkentPrices[itemIndex];
                // Проверяем, какое поле цены используется (price1 или price2)
                const priceWithSums = priceData.price1 || priceData.price2 || '';
                if (priceWithSums.includes('сумов')) {
                  const sumsMatch = priceWithSums.match(/([\d\s]+)\s*сумов/);
                  if (sumsMatch) {
                    const sumsAmount = sumsMatch[1].trim();
                    const uzsValue = `${sumsAmount} UZS`;
                    priceEl.textContent = uzsValue;
                    priceEl.dataset.originalValue = uzsValue;
                    priceEl.dataset.tashkentProcessed = 'true';
                    return;
                  }
                }
              } else {
              }
            } else {
            }
          }
        } catch (e) {
        }
        
        // Если не нашли, оставляем как есть, но не конвертируем
        return;
      }
    }
    
    // Для Ташкента на английской версии: если цена уже обработана и в UZS, не трогаем её
    if (lang === 'en' && isTashkentPrice && priceEl.dataset.tashkentProcessed === 'true') {
      const currentText = priceEl.textContent.trim();
      if (currentText.includes('UZS')) {
        // Уже обработано, не перезаписываем
        return;
      }
    }
    
    // Сохраняем оригинальное значение при первой загрузке
    // НО для Ташкента на английской версии, если текущий текст в UZS или "сумов", сохраняем его правильно
    if (!priceEl.dataset.originalValue) {
      const currentText = priceEl.textContent.trim();
      if (lang === 'en' && isTashkentPrice) {
        // Для Ташкента на английской версии сохраняем в UZS
        if (currentText.includes('UZS')) {
          priceEl.dataset.originalValue = currentText;
          priceEl.dataset.tashkentProcessed = 'true';
          return; // Выходим, не конвертируем
        } else if (currentText.includes('сумов')) {
          // Переводим "сумов" в UZS и сохраняем
          const sumsMatch = currentText.match(/([\d\s]+)\s*сумов/);
          if (sumsMatch) {
            const sumsAmount = sumsMatch[1].trim();
            const uzsValue = `${sumsAmount} UZS`;
            priceEl.dataset.originalValue = uzsValue;
            priceEl.dataset.tashkentProcessed = 'true';
            priceEl.textContent = uzsValue;
            return; // Выходим, не конвертируем
          }
        }
        // Если не UZS и не "сумов", но это Ташкент - НЕ сохраняем рубли/евро как originalValue
        // Для Ташкента должны быть только суммы
        if (currentText.includes('₽') || currentText.includes('€')) {
          // Не сохраняем рубли/евро как originalValue
        } else {
          priceEl.dataset.originalValue = currentText;
        }
      } else {
        priceEl.dataset.originalValue = currentText;
      }
    }
    
    const originalText = priceEl.dataset.originalValue;
    
    if (lang === 'en') {
      // Для кампуса Ташкент на английской версии оставляем суммы (UZS), не конвертируем в рубли или евро
      if (isTashkentPrice) {
        // КРИТИЧЕСКИ ВАЖНО: для Ташкента на английской версии НИКОГДА не конвертируем валюты
        // Если текущий текст уже в UZS, оставляем его и обновляем originalValue
        const currentText = priceEl.textContent.trim();
        if (currentText.includes('UZS')) {
          priceEl.textContent = currentText;
          priceEl.dataset.originalValue = currentText;
          priceEl.dataset.tashkentProcessed = 'true';
          return;
        }
        
        // Если originalValue содержит рубли или евро, но это Ташкент - НЕ используем его
        // Для Ташкента должны быть только суммы
        if (originalText && (originalText.includes('₽') || originalText.includes('€'))) {
          // Игнорируем originalValue с рублями/евро, ищем "сумов" в текущем тексте или в HTML
          const currentText = priceEl.textContent.trim();
          if (currentText.includes('сумов')) {
            const sumsMatch = currentText.match(/([\d\s]+)\s*сумов/);
            if (sumsMatch) {
              const sumsAmount = sumsMatch[1].trim();
              const uzsValue = `${sumsAmount} UZS`;
              priceEl.textContent = uzsValue;
              priceEl.dataset.originalValue = uzsValue;
              priceEl.dataset.tashkentProcessed = 'true';
              return;
            }
          }
          // Если не нашли "сумов", оставляем текущий текст (если он не в рублях/евро)
          if (!currentText.includes('₽') && !currentText.includes('€')) {
            priceEl.textContent = currentText;
            return;
          }
          return; // Не устанавливаем рубли/евро для Ташкента
        }
        
        // Переводим "сумов" на английский (UZS)
        const sumsMatch = originalText.match(/([\d\s]+)\s*сумов/);
        if (sumsMatch) {
          const sumsAmount = sumsMatch[1].trim();
          const uzsValue = `${sumsAmount} UZS`;
          priceEl.textContent = uzsValue;
          priceEl.dataset.originalValue = uzsValue;
          priceEl.dataset.tashkentProcessed = 'true';
        } else if (originalText.includes('UZS')) {
          // Уже в суммах, оставляем как есть
          priceEl.textContent = originalText;
          priceEl.dataset.originalValue = originalText;
          priceEl.dataset.tashkentProcessed = 'true';
        } else {
          // Если в оригинале рубли или евро, но это Ташкент - НЕ конвертируем
          // Для Ташкента должны быть только суммы, поэтому НЕ устанавливаем рубли/евро
          // Оставляем текущий текст, если он не в рублях/евро
          const currentText = priceEl.textContent.trim();
          if (!currentText.includes('₽') && !currentText.includes('€')) {
            priceEl.textContent = currentText;
          }
        }
      } else {
        // Для других кампусов переводим рубли в евро
        const rubMatch = originalText.match(/([\d\s]+)\s*₽/);
        if (rubMatch) {
          const rubAmount = parseInt(rubMatch[1].replace(/\s/g, ''));
          const eurAmount = Math.round(rubAmount / exchangeRate);
          // Форматируем с пробелами для тысяч
          const formattedEur = eurAmount.toLocaleString('en-US').replace(/,/g, ' ');
          priceEl.textContent = `${formattedEur} €`;
        } else {
          // Переводим "сумов" на английский (UZS) для других кампусов тоже
          const sumsMatch = originalText.match(/([\d\s]+)\s*сумов/);
          if (sumsMatch) {
            const sumsAmount = sumsMatch[1].trim();
            priceEl.textContent = `${sumsAmount} UZS`;
          } else {
            // Если уже в евро или других валютах, оставляем оригинальное значение
            priceEl.textContent = originalText;
          }
        }
      }
    } else {
      // Для кампуса Ташкент на русской версии оставляем суммы, не конвертируем в рубли
      if (isTashkentPrice) {
        // КРИТИЧЕСКИ ВАЖНО: для Ташкента на русской версии НИКОГДА не конвертируем в рубли
        const currentText = priceEl.textContent.trim();
        
        // Если текущий текст уже в "сумов", оставляем его
        if (currentText.includes('сумов')) {
          priceEl.textContent = currentText;
          return;
        }
        
        // Переводим "UZS" обратно на "сумов" для русского языка
        const uzsMatch = originalText.match(/([\d\s]+)\s*UZS/);
        if (uzsMatch) {
          const uzsAmount = uzsMatch[1].trim();
          const sumsValue = `${uzsAmount} сумов`;
          priceEl.textContent = sumsValue;
        } else if (originalText.includes('сумов')) {
          // Уже в суммах, оставляем как есть
          priceEl.textContent = originalText;
        } else {
          // Оставляем оригинальное значение (но не рубли!)
          if (!originalText.includes('₽') && !originalText.includes('€')) {
            priceEl.textContent = originalText;
          }
        }
      } else {
        // Для других кампусов: везде евро (рубли убраны, не конвертируем)
        const eurMatch = originalText.match(/([\d\s]+)\s*€/);
        if (eurMatch) {
          const eurAmount = parseInt(eurMatch[1].replace(/\s/g, ''));
          const formattedEur = eurAmount.toLocaleString('ru-RU').replace(/,/g, ' ');
          priceEl.textContent = `${formattedEur} €`;
        } else {
          // Переводим "UZS" обратно на "сумов" для русского языка
          const uzsMatch = originalText.match(/([\d\s]+)\s*UZS/);
          if (uzsMatch) {
            const uzsAmount = uzsMatch[1].trim();
            priceEl.textContent = `${uzsAmount} сумов`;
          } else {
            // Если уже в евро или других валютах, оставляем оригинальное значение
            priceEl.textContent = originalText;
          }
        }
      }
    }
  });

  // Селектор кампусов в Block12
  const block12SelectedCampus = document.getElementById('block12SelectedCampus');
  if (block12SelectedCampus) {
    const campusNames = {
      'skolkovo': t.campus_name_skolkovo,
      'moscow': t.campus_name_moscow,
      'gorki': t.campus_name_gorki,
      'spb': t.campus_name_spb,
      'tashkent': t.campus_name_tashkent
    };
    
    // Маппинг русских названий для определения текущего кампуса
    const campusNamesRu = {
      'Сколково': 'skolkovo',
      'Москва': 'moscow',
      'Горки': 'gorki',
      'Санкт-Петербург': 'spb',
      'Ташкент': 'tashkent'
    };
    
    // Маппинг английских названий для определения текущего кампуса
    const campusNamesEn = {
      'Skolkovo': 'skolkovo',
      'Moscow': 'moscow',
      'Gorki': 'gorki',
      'St. Petersburg': 'spb',
      'Saint Petersburg': 'spb',
      'Tashkent': 'tashkent'
    };
    
    // Определяем текущий кампус
    const currentText = block12SelectedCampus.textContent.trim();
    let campusKey = null;
    
    // Сначала проверяем русские названия
    for (const [name, key] of Object.entries(campusNamesRu)) {
      if (currentText === name || currentText.includes(name)) {
        campusKey = key;
        break;
      }
    }
    
    // Если не нашли, проверяем английские названия
    if (!campusKey) {
      for (const [name, key] of Object.entries(campusNamesEn)) {
        if (currentText === name || currentText.includes(name)) {
          campusKey = key;
          break;
        }
      }
    }
    
    // Если нашли кампус, обновляем текст
    if (campusKey && campusNames[campusKey]) {
      block12SelectedCampus.textContent = campusNames[campusKey];
    }
  }
  
  // Опции в выпадающем списке кампусов в Block12
  const block12CampusOptions = document.querySelectorAll('.block12_campus_option');
  const block12CampusOptionMap = {
    'skolkovo': t.campus_name_skolkovo,
    'moscow': t.campus_name_moscow,
    'gorki': t.campus_name_gorki,
    'spb': t.campus_name_spb,
    'tashkent': t.campus_name_tashkent
  };
  
  block12CampusOptions.forEach((opt) => {
    const dataCampus = opt.getAttribute('data-campus');
    if (dataCampus && block12CampusOptionMap[dataCampus]) {
      opt.textContent = block12CampusOptionMap[dataCampus];
    }
  });

  // Всплывающие окна кампусов в формах
  const formCampusIdToSlug = { '1': 'spb', '2': 'moscow', '3': 'gorki', '4': 'tashkent', '5': 'skolkovo' };
  const getFormCampusKey = (v) => formCampusIdToSlug[v] || v;

  const formCampusOptions = document.querySelectorAll('.form_campus_option');
  formCampusOptions.forEach(opt => {
    const dataValue = opt.getAttribute('data-value');
    const key = getFormCampusKey(dataValue);
    if (dataValue && t[`campus_name_${key}`]) {
      opt.textContent = t[`campus_name_${key}`];
    }
  });

  const formSelectedCampus = document.getElementById('formSelectedCampus');
  if (formSelectedCampus) {
    const formCampusInput = document.getElementById('campus');
    const campusValue = formCampusInput ? formCampusInput.value : null;
    const key = getFormCampusKey(campusValue);
    
    if (campusValue && t[`campus_name_${key}`]) {
      formSelectedCampus.textContent = t[`campus_name_${key}`];
    } else {
      // Если не нашли по value, определяем по текущему тексту
      const currentText = formSelectedCampus.textContent.trim();
      const campusMap = {
        'Сколково': 'skolkovo',
        'Skolkovo': 'skolkovo',
        'Москва': 'moscow',
        'Moscow': 'moscow',
        'Горки': 'gorki',
        'Gorki': 'gorki',
        'Санкт-Петербург': 'spb',
        'Saint Petersburg': 'spb',
        'St. Petersburg': 'spb',
        'Ташкент': 'tashkent',
        'Tashkent': 'tashkent'
      };
      
      for (const [name, value] of Object.entries(campusMap)) {
        if (currentText === name || currentText.includes(name)) {
          if (t[`campus_name_${value}`]) {
            formSelectedCampus.textContent = t[`campus_name_${value}`];
          }
          break;
        }
      }
    }
  }

  const campusSelects = document.querySelectorAll('select[name="campus"] option');
  campusSelects.forEach(opt => {
    if (opt.value === '') {
      opt.textContent = t.campus_select_placeholder;
    } else if (opt.value && t[`campus_name_${opt.value}`]) {
      opt.textContent = t[`campus_name_${opt.value}`];
    }
  });
  
  // Обновляем переводы кампусов в форме block7
  if (typeof window.updateBlock7CampusTranslations === 'function') {
    window.updateBlock7CampusTranslations();
  }
  
  // Обновляем плейсхолдер телефона в форме block7 (зависит от кода страны)
  if (typeof window.updateBlock7PhoneLimits === 'function') {
    window.updateBlock7PhoneLimits();
  }

  // Block14 - Наша команда
  const block14Title = document.querySelector('.block14_title');
  if (block14Title) block14Title.textContent = t.block14_title;

  const block14Subtitle = document.querySelector('.block14_subtitle');
  if (block14Subtitle) block14Subtitle.textContent = t.block14_subtitle;

  const block14Btn = document.querySelector('.block14_btn');
  if (block14Btn) block14Btn.textContent = t.block14_btn;

  const block14ReviewsTitle = document.querySelector('.block14_reviews_title');
  if (block14ReviewsTitle) block14ReviewsTitle.textContent = t.block14_reviews_title;

  // Преподаватели - обновляем через applyTeachers для текущего кампуса
  // Приоритет: явный выбор пользователя (block14_campus_selector_btn) > активная кнопка > текст селектора > default
  setTimeout(() => {
    let currentCampus = null;
    let source = '';
    
    // Приоритет 1: явный выбор пользователя в block14_campus_selector_btn (en-uz: не перезаписывать на Ташкент)
    if (window.block14UserSelectedCampus) {
      currentCampus = window.block14UserSelectedCampus;
      source = 'block14UserSelectedCampus';
    }
    
    if (!currentCampus) {
      // Приоритет 2: активная кнопка block14_campus_btn
      const activeCampusBtn = document.querySelector('.block14_campus_btn.active');
      if (activeCampusBtn) {
        currentCampus = activeCampusBtn.getAttribute('data-campus') || null;
        source = 'activeCampusBtn';
      }
    }
    
    if (!currentCampus) {
      // Приоритет 3: текст в селекторе
      const block14SelectedCampus = document.getElementById('block14SelectedCampus');
      if (block14SelectedCampus) {
        const campusText = block14SelectedCampus.textContent.trim().toLowerCase();
        const campusMap = {
          'skolkovo': 'skolkovo',
          'сколково': 'skolkovo',
          'moscow': 'moscow',
          'москва': 'moscow',
          'gorki': 'gorki',
          'горки': 'gorki',
          'spb': 'spb',
          'санкт-петербург': 'spb',
          'st. petersburg': 'spb',
          'saint petersburg': 'spb',
          'tashkent': 'tashkent',
          'ташкент': 'tashkent'
        };
        currentCampus = campusMap[campusText] || null;
        source = currentCampus ? 'campusText' : source;
      }
    }
    
    if (!currentCampus) {
      // Приоритет 4: default по URL (en-uz/ru-uz = tashkent)
      const pathMatch = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(\/.*)?$/);
      currentCampus = (pathMatch && pathMatch[2] === 'uz') ? 'tashkent' : 'gorki';
      source = 'urlDefault';
    }
    
    if (typeof window.applyTeachers === 'function') {
      window.applyTeachers(currentCampus);
    }
    if (typeof window.updateBlock14SelectorDisplay === 'function') {
      window.updateBlock14SelectorDisplay(currentCampus);
    }
  }, 150);
  
  // Кнопки кампусов в Block14
  const block14CampusBtns = document.querySelectorAll('.block14_campus_btn');
  const block14CampusTranslations = {
    'skolkovo': t.block12_campus_skolkovo,
    'moscow': t.block12_campus_moscow,
    'gorki': t.block12_campus_gorki,
    'spb': t.block12_campus_spb,
    'tashkent': t.block12_campus_tashkent
  };
  block14CampusBtns.forEach(btn => {
    const dataCampus = btn.getAttribute('data-campus');
    if (dataCampus && block14CampusTranslations[dataCampus]) {
      btn.innerHTML = block14CampusTranslations[dataCampus];
    }
  });
  
  // Селектор кампусов в Block14 — приоритет: block14UserSelectedCampus, затем текст в DOM
  const block14SelectedCampus = document.getElementById('block14SelectedCampus');
  if (block14SelectedCampus) {
    const campusNames = {
      'skolkovo': t.campus_name_skolkovo,
      'moscow': t.campus_name_moscow,
      'gorki': t.campus_name_gorki,
      'spb': t.campus_name_spb,
      'tashkent': t.campus_name_tashkent
    };
    
    let campusKey = window.block14UserSelectedCampus || null;
    
    if (!campusKey) {
      // Fallback: маппинг по тексту в селекторе
      const campusNamesRu = { 'Сколково': 'skolkovo', 'Москва': 'moscow', 'Горки': 'gorki', 'Санкт-Петербург': 'spb', 'Ташкент': 'tashkent' };
      const campusNamesEn = { 'Skolkovo': 'skolkovo', 'Moscow': 'moscow', 'Gorki': 'gorki', 'St. Petersburg': 'spb', 'Saint Petersburg': 'spb', 'Tashkent': 'tashkent' };
      const currentText = block14SelectedCampus.textContent.trim();
      for (const [name, key] of Object.entries(campusNamesRu)) {
        if (currentText === name || currentText.includes(name)) { campusKey = key; break; }
      }
      if (!campusKey) {
        for (const [name, key] of Object.entries(campusNamesEn)) {
          if (currentText === name || currentText.includes(name)) { campusKey = key; break; }
        }
      }
    }
    
    if (campusKey && campusNames[campusKey]) {
      document.querySelectorAll('[id="block14SelectedCampus"], [id="block14SelectedCampusMobile"]').forEach(el => {
        el.textContent = campusNames[campusKey];
      });
    }
  }
  
  // Опции в выпадающем списке кампусов в Block14
  const block14CampusOptions = document.querySelectorAll('.block14_campus_option');
  const block14CampusOptionMap = {
    'skolkovo': t.campus_name_skolkovo,
    'moscow': t.campus_name_moscow,
    'gorki': t.campus_name_gorki,
    'spb': t.campus_name_spb,
    'tashkent': t.campus_name_tashkent
  };
  
  block14CampusOptions.forEach((opt) => {
    const dataCampus = opt.getAttribute('data-campus');
    if (dataCampus && block14CampusOptionMap[dataCampus]) {
      opt.textContent = block14CampusOptionMap[dataCampus];
    }
  });

  if (typeof window.updateBlock14SelectorDisplay === 'function') {
    let campusId = window.block14UserSelectedCampus || null;
    if (!campusId && block14SelectedCampus) {
      const txt = block14SelectedCampus.textContent.trim();
      const ru = { 'Сколково': 'skolkovo', 'Москва': 'moscow', 'Горки': 'gorki', 'Санкт-Петербург': 'spb', 'Ташкент': 'tashkent' };
      const en = { 'Skolkovo': 'skolkovo', 'Moscow': 'moscow', 'Gorki': 'gorki', 'St. Petersburg': 'spb', 'Saint Petersburg': 'spb', 'Tashkent': 'tashkent' };
      for (const [name, key] of Object.entries(ru)) {
        if (txt === name || txt.includes(name)) { campusId = key; break; }
      }
      if (!campusId) {
        for (const [name, key] of Object.entries(en)) {
          if (txt === name || txt.includes(name)) { campusId = key; break; }
        }
      }
    }
    if (campusId) window.updateBlock14SelectorDisplay(campusId);
  }

  // Отзывы учителей
  const reviewNames = document.querySelectorAll('.review_name');
  const reviewPositions = document.querySelectorAll('.review_position');
  const reviewTexts = document.querySelectorAll('.review_text');
  const reviewExpands = document.querySelectorAll('.review_expand');
  
  if (reviewNames.length >= 6) {
    // Используем все 7 отзывов (если есть review_name_7, иначе только 6)
    const reviewNamesTranslations = [
      t.review_name_1, t.review_name_2, t.review_name_3, t.review_name_4,
      t.review_name_5, t.review_name_6, t.review_name_7 || ''
    ].filter(Boolean);
    const reviewPositionsTranslations = [
      t.review_position_1, t.review_position_2, t.review_position_3, t.review_position_4,
      t.review_position_5, t.review_position_6, t.review_position_7 || ''
    ].filter(Boolean);
    const reviewTextsTranslations = [
      t.review_text_1, t.review_text_2, t.review_text_3, t.review_text_4,
      t.review_text_5, t.review_text_6, t.review_text_7 || ''
    ].filter(Boolean);
    
    reviewNames.forEach((name, index) => {
      // Используем модуль для циклического применения переводов
      const translationIndex = index % reviewNamesTranslations.length;
      if (translationIndex < reviewNamesTranslations.length && reviewNamesTranslations[translationIndex]) {
        name.textContent = reviewNamesTranslations[translationIndex];
      }
    });
    reviewPositions.forEach((position, index) => {
      const translationIndex = index % reviewPositionsTranslations.length;
      if (translationIndex < reviewPositionsTranslations.length && reviewPositionsTranslations[translationIndex]) {
        position.textContent = reviewPositionsTranslations[translationIndex];
      }
    });
    reviewTexts.forEach((text, index) => {
      const translationIndex = index % reviewTextsTranslations.length;
      if (translationIndex < reviewTextsTranslations.length && reviewTextsTranslations[translationIndex]) {
        text.textContent = reviewTextsTranslations[translationIndex];
      }
    });
  }
  
  // Переводим кнопки "Развернуть/Свернуть" с учетом их состояния
  reviewExpands.forEach(btn => {
    const reviewCard = btn.closest('.review_card');
    if (reviewCard && reviewCard.classList.contains('expanded')) {
      btn.textContent = t.review_collapse;
    } else {
      btn.textContent = t.review_expand;
    }
  });

  // Block15 - Наши выпускники
  const block15Title = document.querySelector('.block15_title');
  if (block15Title) block15Title.textContent = t.block15_title;

  const block15Description = document.querySelector('.block15_description');
  if (block15Description) {
    // Проверяем регион
    const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    const descriptionText = isUzbekistan && t.block15_description_mobile_uzbekistan
      ? t.block15_description_mobile_uzbekistan
      : (t.block15_description || '');
    
    block15Description.innerHTML = descriptionText;
  }

  // Аккордеоны
  const alumniAccordionInfoItems = document.querySelectorAll('.alumni_accordion_item .accordion_info');
  if (alumniAccordionInfoItems.length >= 2) {
    alumniAccordionInfoItems[0].textContent = t.block15_accordion_universities;
    alumniAccordionInfoItems[1].textContent = t.block15_accordion_association;
  }

  // Условная замена контента аккордеона "Прием в университеты" при 768px
  const firstAlumniAccordionItem = document.querySelector('.alumni_accordion_item');
  const alumniAccordionContent = firstAlumniAccordionItem?.querySelector('.accordion_content');
  
  if (alumniAccordionContent) {
    const isMobile = window.innerWidth <= 768;
    
    // Сохраняем оригинальный HTML при первой загрузке, если еще не сохранен
    if (!alumniAccordionContent.dataset.originalHtml) {
      alumniAccordionContent.dataset.originalHtml = alumniAccordionContent.innerHTML;
    }
    
    if (isMobile) {
      // Мобильная версия: новый текст + изображение
      const mobileHtml = `
        <div class="alumni_content_wrapper">
          <div class="alumni_left_column">
            <p class="alumni_intro">
              ${(() => {
                // Проверяем регион для выбора правильного текста
                const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
                let text = (isUzbekistan && t.block15_alumni_intro_mobile_uzbekistan)
                  ? t.block15_alumni_intro_mobile_uzbekistan
                  : (t.block15_alumni_intro_mobile || t.block15_alumni_intro || '');
                // Сохраняем дефисы внутри скобок (например, Year 11–13)
                text = text.replace(/\(([^)]*–[^)]*)\)/g, (match) => match.replace(/–/g, '___TEMP_DASH___'));
                // Заменяем остальные дефисы на красные
                text = text.replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>');
                // Возвращаем дефисы внутри скобок обратно
                text = text.replace(/___TEMP_DASH___/g, '–');
                return text;
              })()}
            </p>
            
            <div class="alumni_diagram">
              <img src="${landingAssetPath('/landing_2025/src/img/' + (lang === 'en' ? 'alumni Diagram 2013-2024 250225-2_ENG.jpg' : 'alumni Diagram 2013-2024 250225-2_RUS.jpg'))}" alt="${lang === 'en' ? 'University acceptance diagram' : 'Диаграмма поступлений'}" />
            </div>
            
            <div class="alumni_universities_mobile">
              <p><strong>${t.block15_alumni_geography_mobile || 'География поступлений:'}</strong></p>
              <p>${(t.block15_alumni_geography_uk_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
              <p>${(t.block15_alumni_geography_usa_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
              <p>${(t.block15_alumni_geography_russia_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
              <p>${(t.block15_alumni_geography_uzbekistan_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
              <p>${(t.block15_alumni_geography_uae_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
              <p>${(t.block15_alumni_geography_switzerland_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            </div>
          </div>
        </div>
      `;
      alumniAccordionContent.innerHTML = mobileHtml;
    } else {
      // Десктопная версия (769px+): используем новый текст как в мобильной версии
      const desktopHtml = `
        <div class="alumni_content_wrapper">
          <div class="alumni_left_column">
            <p class="alumni_intro">
              ${(() => {
                // Проверяем регион для выбора правильного текста
                const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
                let text = (isUzbekistan && t.block15_alumni_intro_mobile_uzbekistan)
                  ? t.block15_alumni_intro_mobile_uzbekistan
                  : (t.block15_alumni_intro_mobile || t.block15_alumni_intro || '');
                // Сохраняем дефисы внутри скобок (например, Year 11–13)
                text = text.replace(/\(([^)]*–[^)]*)\)/g, (match) => match.replace(/–/g, '___TEMP_DASH___'));
                // Заменяем остальные дефисы на красные
                text = text.replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>');
                // Возвращаем дефисы внутри скобок обратно
                text = text.replace(/___TEMP_DASH___/g, '–');
                return text;
              })()}
            </p>
            
            <div class="alumni_diagram">
              <img src="${landingAssetPath('/landing_2025/src/img/' + (lang === 'en' ? 'alumni Diagram 2013-2024 250225-2_ENG.jpg' : 'alumni Diagram 2013-2024 250225-2_RUS.jpg'))}" alt="${lang === 'en' ? 'University acceptance diagram' : 'Диаграмма поступлений'}" />
            </div>
            
            <div class="alumni_universities_mobile">
              <p><strong>${t.block15_alumni_geography_mobile || 'География поступлений:'}</strong></p>
              <p>${(t.block15_alumni_geography_uk_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
              <p>${(t.block15_alumni_geography_usa_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
              <p>${(t.block15_alumni_geography_russia_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
              <p>${(t.block15_alumni_geography_uzbekistan_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
              <p>${(t.block15_alumni_geography_uae_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
              <p>${(t.block15_alumni_geography_switzerland_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            </div>
          </div>
        </div>
      `;
      alumniAccordionContent.innerHTML = desktopHtml;
    }
  } else {
    // Если контент не найден, обновляем как обычно
    const alumniIntro = document.querySelector('.alumni_intro');
    if (alumniIntro) alumniIntro.textContent = t.block15_alumni_intro;
  }

  // Условная замена контента аккордеона "Ассоциация выпускников" при 768px
  const alumniAccordionItems = document.querySelectorAll('.alumni_accordion_item');
  const secondAlumniAccordionItem = alumniAccordionItems.length >= 2 ? alumniAccordionItems[1] : null;
  const secondAlumniAccordionContent = secondAlumniAccordionItem?.querySelector('.accordion_content');
  
  if (secondAlumniAccordionContent) {
    const isMobile = window.innerWidth <= 768;
    
    // Сохраняем оригинальный HTML при первой загрузке, если еще не сохранен
    if (!secondAlumniAccordionContent.dataset.originalHtml) {
      secondAlumniAccordionContent.dataset.originalHtml = secondAlumniAccordionContent.innerHTML;
    }
    
    if (isMobile) {
      // Мобильная версия: новый текст
      const mobileHtml = `
        <div class="alumni_association_content">
          <p class="alumni_association_lead">
            ${t.block15_association_mobile || t.block15_association_lead}
          </p>
          <div class="alumni_association_main">
            <p><strong>${t.block15_association_formats_mobile || 'Форматы взаимодействия:'}</strong></p>
            <p><span class="accordion_dash">—</span> ${t.block15_association_format1_mobile ? t.block15_association_format1_mobile.replace('— ', '') : 'мероприятия и встречи;'}</p>
            <p><span class="accordion_dash">—</span> ${t.block15_association_format2_mobile ? t.block15_association_format2_mobile.replace('— ', '') : 'общение в социальных сетях;'}</p>
            <p><span class="accordion_dash">—</span> ${t.block15_association_format3_mobile ? t.block15_association_format3_mobile.replace('— ', '') : 'программа наставничества;'}</p>
            <p><span class="accordion_dash">—</span> ${t.block15_association_format4_mobile ? t.block15_association_format4_mobile.replace('— ', '') : 'волонтёрство и пожертвования;'}</p>
            <p><span class="accordion_dash">—</span> ${t.block15_association_format5_mobile ? t.block15_association_format5_mobile.replace('— ', '') : 'карьерная поддержка.'}</p>
          </div>
        </div>
      `;
      secondAlumniAccordionContent.innerHTML = mobileHtml;
    } else {
      // Десктопная версия (769px+): используем новый текст как в мобильной версии
      const desktopHtml = `
        <div class="alumni_association_content">
          <p class="alumni_association_lead">
            ${t.block15_association_mobile || t.block15_association_lead}
          </p>
          <div class="alumni_association_main">
            <p><strong>${t.block15_association_formats_mobile || 'Форматы взаимодействия:'}</strong></p>
            <p><span class="accordion_dash">—</span> ${t.block15_association_format1_mobile ? t.block15_association_format1_mobile.replace('— ', '') : 'мероприятия и встречи;'}</p>
            <p><span class="accordion_dash">—</span> ${t.block15_association_format2_mobile ? t.block15_association_format2_mobile.replace('— ', '') : 'общение в социальных сетях;'}</p>
            <p><span class="accordion_dash">—</span> ${t.block15_association_format3_mobile ? t.block15_association_format3_mobile.replace('— ', '') : 'программа наставничества;'}</p>
            <p><span class="accordion_dash">—</span> ${t.block15_association_format4_mobile ? t.block15_association_format4_mobile.replace('— ', '') : 'волонтёрство и пожертвования;'}</p>
            <p><span class="accordion_dash">—</span> ${t.block15_association_format5_mobile ? t.block15_association_format5_mobile.replace('— ', '') : 'карьерная поддержка.'}</p>
          </div>
        </div>
      `;
      secondAlumniAccordionContent.innerHTML = desktopHtml;
    }
  } else {
    // Если контент не найден, обновляем как обычно
    const alumniAssociationLead = document.querySelector('.alumni_association_lead');
    if (alumniAssociationLead) alumniAssociationLead.textContent = t.block15_association_lead;

    const alumniAssociationTexts = document.querySelectorAll('.alumni_association_text');
    if (alumniAssociationTexts.length >= 2) {
      alumniAssociationTexts[0].textContent = t.block15_association_text_1;
      alumniAssociationTexts[1].textContent = t.block15_association_text_2;
    }
  }

  // Перевод стран и университетов в Block15
  const countryTitles = document.querySelectorAll('.country_title');
  const countryTranslations = {
    'Великобритания': t.country_uk,
    'United Kingdom': t.country_uk,
    'США': t.country_usa,
    'USA': t.country_usa,
    'Россия': t.country_russia,
    'Russia': t.country_russia,
    'Узбекистан': t.country_uzbekistan,
    'Uzbekistan': t.country_uzbekistan,
    'Объединённые Арабские Эмираты': t.country_uae,
    'United Arab Emirates': t.country_uae,
    'Швейцария': t.country_switzerland,
    'Switzerland': t.country_switzerland,
    'Италия': t.country_italy,
    'Italy': t.country_italy,
    'Канада': t.country_canada,
    'Canada': t.country_canada,
    'Венгрия': t.country_hungary,
    'Hungary': t.country_hungary,
    'Германия': t.country_germany,
    'Germany': t.country_germany,
    'Нидерланды': t.country_netherlands,
    'Netherlands': t.country_netherlands,
    'Китай': t.country_china,
    'China': t.country_china,
    'Финляндия': t.country_finland,
    'Finland': t.country_finland,
    'Польша': t.country_poland,
    'Poland': t.country_poland,
    'Бельгия': t.country_belgium,
    'Belgium': t.country_belgium
  };
  
  // Сохраняем маппинг оригинальных названий к ключам стран
  const countryKeyMap = {
    'Великобритания': 'uk',
    'United Kingdom': 'uk',
    'США': 'usa',
    'USA': 'usa',
    'Россия': 'russia',
    'Russia': 'russia',
    'Узбекистан': 'uzbekistan',
    'Uzbekistan': 'uzbekistan',
    'Объединённые Арабские Эмираты': 'uae',
    'United Arab Emirates': 'uae',
    'Швейцария': 'switzerland',
    'Switzerland': 'switzerland',
    'Италия': 'italy',
    'Italy': 'italy',
    'Канада': 'canada',
    'Canada': 'canada',
    'Венгрия': 'hungary',
    'Hungary': 'hungary',
    'Германия': 'germany',
    'Germany': 'germany',
    'Нидерланды': 'netherlands',
    'Netherlands': 'netherlands',
    'Китай': 'china',
    'China': 'china',
    'Финляндия': 'finland',
    'Finland': 'finland',
    'Польша': 'poland',
    'Poland': 'poland',
    'Бельгия': 'belgium',
    'Belgium': 'belgium'
  };
  
  // Сохраняем оригинальные названия стран перед переводом
  const countryTitleMap = new Map();
  countryTitles.forEach(title => {
    const originalText = title.textContent.trim();
    countryTitleMap.set(title, originalText);
    
    // Переводим название страны
    if (countryTranslations[originalText]) {
      title.textContent = countryTranslations[originalText];
    }
  });
  
  // Перевод университетов
  const universityLists = document.querySelectorAll('.university_list');
  universityLists.forEach(list => {
    // Ищем заголовок страны - может быть предыдущим элементом или внутри общего контейнера
    let countryTitle = list.previousElementSibling;
    if (!countryTitle || !countryTitle.classList.contains('country_title')) {
      // Если не нашли как предыдущий элемент, ищем в родительском контейнере
      const parent = list.closest('.alumni_universities_column');
      if (parent) {
        // Ищем все заголовки стран в этом контейнере и находим тот, который идет перед нашим списком
        const allTitles = parent.querySelectorAll('.country_title');
        for (let i = 0; i < allTitles.length; i++) {
          const title = allTitles[i];
          let nextEl = title.nextElementSibling;
          // Проверяем следующие элементы до тех пор, пока не найдем наш список
          while (nextEl) {
            if (nextEl === list) {
              countryTitle = title;
              break;
            }
            if (nextEl.classList && nextEl.classList.contains('country_title')) {
              // Если встретили следующий заголовок страны, значит наш список относится к предыдущему
              break;
            }
            nextEl = nextEl.nextElementSibling;
          }
          if (countryTitle && countryTitle.classList && countryTitle.classList.contains('country_title')) break;
        }
      }
    }
    
    if (!countryTitle) return;
    
    // Используем оригинальное название страны для определения ключа
    const originalCountryName = countryTitleMap.get(countryTitle) || countryTitle.textContent.trim();
    const countryKey = countryKeyMap[originalCountryName];
    
    if (countryKey) {
      const listItems = list.querySelectorAll('li');
      listItems.forEach((item, index) => {
        const translationKey = `university_${countryKey}_${index + 1}`;
        if (t[translationKey]) {
          item.textContent = t[translationKey];
        }
      });
    }
  });

  // Block13 - Лицензии и аккредитации
  const block13Title = document.querySelector('.block13_title');
  if (block13Title) block13Title.textContent = t.block13_title;

  const block13Subtitles = document.querySelectorAll('.block13_card_subtitle');
  const block13Infos = document.querySelectorAll('.block13_card_info');
  // Исключаем кнопки из третьей карточки (они имеют свои тексты "Школа" и "Детский сад")
  const block13DownloadBtns = document.querySelectorAll('.block13_card_btn:not(.block13_card_btn_school):not(.block13_card_btn_kindergarten) span');
  
  if (block13Subtitles.length >= 3) {
    block13Subtitles[0].textContent = t.block13_card1_subtitle;
    block13Subtitles[1].textContent = t.block13_card2_subtitle;
    block13Subtitles[2].textContent = t.block13_card3_subtitle;
  }
  
  if (block13Infos.length >= 3) {
    block13Infos[0].innerHTML = t.block13_card1_info;
    block13Infos[1].innerHTML = t.block13_card2_info;
    block13Infos[2].innerHTML = t.block13_card3_info;
  }
  
  // Обновляем только кнопки "Скачать сертификат" (не трогаем кнопки "Школа" и "Детский сад")
  block13DownloadBtns.forEach(btn => {
    btn.textContent = t.block13_download_certificate;
  });
  
  // Обновляем тексты для кнопок в третьей карточке
  const block13SchoolBtn = document.querySelector('.block13_card_btn_school span');
  const block13KindergartenBtn = document.querySelector('.block13_card_btn_kindergarten span');
  
  if (block13SchoolBtn) {
    block13SchoolBtn.textContent = t.block13_btn_school;
  }
  
  if (block13KindergartenBtn) {
    block13KindergartenBtn.textContent = t.block13_btn_kindergarten;
  }

  // Block17 - FAQ (или FAQ детского сада на странице Early Years)
  const block17Title = document.querySelector('.block17_title');
  const isFaqKindergarten = document.querySelector('.faq-kindergarten');
  /* Начальная / средняя / старшая: тексты из YAML, атрибут data-secondary-faq — не применять логику главной (14 вопросов, скрытие первого) */
  const isInternal2025SchoolFaq = document.querySelector('[data-secondary-faq]') && !isFaqKindergarten;
  if (block17Title && !isInternal2025SchoolFaq) {
    block17Title.textContent = t.block17_title;
  }
  const leftColumn = document.querySelector('.block17_column:first-of-type');
  const rightColumn = document.querySelector('.block17_column:last-of-type');
  const leftItems = leftColumn ? Array.from(leftColumn.querySelectorAll('.block17_accordion_item')) : [];
  const rightItems = rightColumn ? Array.from(rightColumn.querySelectorAll('.block17_accordion_item')) : [];

  if (isFaqKindergarten) {
    // FAQ детского сада: 12 вопросов, перевод faq_kg_*, ответы 1, 5, 8 с вариантом _uz для Узбекистана
    if (block17Title && t.faq_kg_title) block17Title.textContent = t.faq_kg_title;
    const isUz = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    const kgMapping = [
      { item: leftItems[0], q: 1, a: 1, uzKey: 'faq_kg_a1_uz' },
      { item: rightItems[0], q: 2, a: 2 },
      { item: leftItems[1], q: 3, a: 3 },
      { item: rightItems[1], q: 4, a: 4 },
      { item: leftItems[2], q: 5, a: 5, uzKey: 'faq_kg_a5_uz' },
      { item: rightItems[2], q: 6, a: 6 },
      { item: leftItems[3], q: 7, a: 7 },
      { item: rightItems[3], q: 8, a: 8, uzKey: 'faq_kg_a8_uz' },
      { item: leftItems[4], q: 9, a: 9 },
      { item: rightItems[4], q: 10, a: 10 },
      { item: leftItems[5], q: 11, a: 11 },
      { item: rightItems[5], q: 12, a: 12 }
    ];
    kgMapping.forEach(({ item, q, a, uzKey }) => {
      if (!item) return;
      const questionEl = item.querySelector('.block17_accordion_info');
      const answerEl = item.querySelector('.block17_accordion_content');
      if (questionEl && t['faq_kg_q' + q]) questionEl.textContent = t['faq_kg_q' + q];
      if (answerEl) {
        let answerText = isUz && uzKey && t[uzKey] ? t[uzKey] : t['faq_kg_a' + a];
        answerEl.innerHTML = '<p>' + (answerText || '') + '</p>';
      }
      item.style.display = '';
    });
    [...leftItems, ...rightItems].forEach(item => {
      if (item && !kgMapping.some(m => m.item === item)) item.style.display = 'none';
    });
  } else if (block17Title && !isInternal2025SchoolFaq) {
    // FAQ главной страницы: 14 вопросов, block17_*, первый элемент левой колонки скрыт
    block17Title.textContent = t.block17_title;
    const isUzbekistanBlock17 = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    if (leftItems[0]) leftItems[0].style.display = 'none';
    [...leftItems, ...rightItems].forEach(item => {
      if (!item) return;
      const questionEl = item.querySelector('.block17_accordion_info');
      const answerEl = item.querySelector('.block17_accordion_content');
      if (questionEl) questionEl.textContent = '';
      if (answerEl) answerEl.innerHTML = '';
    });
    const questionMapping = [
      { item: leftItems[1], q: 1, a: 1 },   { item: leftItems[2], q: 2, a: 2 },   { item: leftItems[3], q: 3, a: 3 },
      { item: leftItems[4], q: 4, a: 4 },   { item: leftItems[5], q: 5, a: 5 },   { item: leftItems[6], q: 6, a: 6 },
      { item: leftItems[7], q: 7, a: 7 },   { item: rightItems[0], q: 8, a: 8 },   { item: rightItems[1], q: 9, a: 9 },
      { item: rightItems[2], q: 10, a: 10 }, { item: rightItems[3], q: 11, a: 11 }, { item: rightItems[4], q: 12, a: 12 },
      { item: rightItems[5], q: 13, a: 13 }, { item: rightItems[6], q: 14, a: 14 }
    ];
    const processedItems = new Set();
    questionMapping.forEach(({ item, q, a }) => {
      if (!item) return;
      if (processedItems.has(item)) return;
      processedItems.add(item);
      const questionEl = item.querySelector('.block17_accordion_info');
      const answerEl = item.querySelector('.block17_accordion_content');
      if (questionEl && t['block17_question' + q]) questionEl.textContent = t['block17_question' + q];
      if (answerEl) {
        let answerText = t['block17_answer' + a];
        if (a === 4 && isUzbekistanBlock17 && t.block17_answer4_uzbekistan) answerText = t.block17_answer4_uzbekistan;
        else if (a === 5 && isUzbekistanBlock17 && t.block17_answer5_uzbekistan) answerText = t.block17_answer5_uzbekistan;
        else if (a === 6 && isUzbekistanBlock17 && t.block17_answer6_uzbekistan) answerText = t.block17_answer6_uzbekistan;
        else if (a === 9 && isUzbekistanBlock17 && t.block17_answer9_uzbekistan) answerText = t.block17_answer9_uzbekistan;
        else if (a === 11 && isUzbekistanBlock17 && t.block17_answer11_uzbekistan) answerText = t.block17_answer11_uzbekistan;
        answerEl.innerHTML = '<p>' + answerText + '</p>';
      }
    });
    [...leftItems, ...rightItems].forEach(item => {
      if (!item) return;
      if (!processedItems.has(item) && item !== leftItems[0]) item.style.display = 'none';
    });
  }

  // Block18 - Форма вопросов
  const block18FormTxts = document.querySelectorAll('#block18 .form_txt');
  block18FormTxts.forEach(formTxt => {
    formTxt.textContent = t.block18_title;
  });

  // Block19 - Новости / Статьи (на странице детского сада — статьи из CMS)
  const block19Section = document.querySelector('.block19');
  const block19Title = document.querySelector('.block19_title');
  const isArticlesBlock = block19Section && block19Section.classList.contains('block19_articles');
  if (block19Title) {
    block19Title.textContent = isArticlesBlock ? t.block19_articles_title : t.block19_title;
  }

  // Перевод заголовков новостей (только реальные карточки, клоны будут склонированы с уже переведенным текстом)
  // Используем data-title-ru/data-title-en из карточки (из БД), чтобы заголовок соответствовал ссылке
  const realNewsCards = document.querySelectorAll('#newsSlides .news_card:not(.news-card-clone)');
  realNewsCards.forEach((card, index) => {
    const titleEl = card.querySelector('.news_title');
    if (!titleEl) return;
    const titleRu = card.dataset.titleRu;
    const titleEn = card.dataset.titleEn;
    if (titleRu !== undefined && titleEn !== undefined) {
      titleEl.textContent = (lang === 'en' ? titleEn : titleRu) || titleEl.textContent;
    } else if (!isArticlesBlock) {
      // Статические три карточки на главной — подставляем переводы из JSON.
      // Блок статей из CMS (block19_articles): без data-title-* оставляем серверный заголовок — иначе
      // подставлялись block19_news1–3 и не совпадали со ссылкой на реальную статью.
      const fallback = [t.block19_news1_title, t.block19_news2_title, t.block19_news3_title][index];
      if (fallback) titleEl.textContent = fallback;
    }
  });
  
  // // Перевод заголовков новостей (только для блока новостей, не для статей — статьи приходят из CMS и не переводятся здесь)
  // const realNewsCards = document.querySelectorAll('#newsSlides .news_card:not(.news-card-clone)');
  // if (!isArticlesBlock && realNewsCards.length >= 3) {
  //   const newsTitles = [
  //     realNewsCards[0].querySelector('.news_title'),
  //     realNewsCards[1].querySelector('.news_title'),
  //     realNewsCards[2].querySelector('.news_title')
  //   ];
  //   if (newsTitles[0]) newsTitles[0].textContent = t.block19_news1_title;
  //   if (newsTitles[1]) newsTitles[1].textContent = t.block19_news2_title;
  //   if (newsTitles[2]) newsTitles[2].textContent = t.block19_news3_title;
  // }
  
  // Перевод дат новостей (только реальные карточки)
  realNewsCards.forEach((card, index) => {
    if (index < 3) {
      const dateEl = card.querySelector('.news_date');
      if (dateEl) {
        const originalDate = dateEl.textContent.trim();
        const translatedDate = translateDate(originalDate, lang);
        if (translatedDate !== originalDate) {
          dateEl.textContent = translatedDate;
        }
      }
    }
  });

  // Block19_reviews - Отзывы родителей
  const block19ReviewsMainTitle = document.querySelector('.block19_reviews_main_title');
  if (block19ReviewsMainTitle) block19ReviewsMainTitle.textContent = t.block19_reviews_main_title;

  const block19ReviewsTitle = document.querySelector('.block19_reviews_title');
  if (block19ReviewsTitle) block19ReviewsTitle.textContent = t.block19_reviews_title;

  // Отзывы родителей
  // Получаем только реальные карточки (без клонов)
  const parentReviewsSlidesEl = document.getElementById('parentReviewsSlides');
  const parentReviewCards = parentReviewsSlidesEl ? parentReviewsSlidesEl.querySelectorAll('.block19_review_card:not(.block19-parent-review-card-clone)') : [];
  const parentReviewExpands = document.querySelectorAll('.block19_review_expand');
  
  // Если отзывы из CMS — НЕ перезаписываем их статическими данными из JS
  const hasCmsReviews = parentReviewsSlidesEl && parentReviewsSlidesEl.dataset.cmsReviews === 'true';
  
  // Определяем регион для выбора правильных отзывов
  const isUzbekistanReviews = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
  
  // Показываем/скрываем 4-ю карточку в зависимости от региона (только для статических отзывов, т.к. у CMS может быть другое кол-во)
  if (!hasCmsReviews && parentReviewCards.length >= 4) {
    const fourthCard = parentReviewCards[3]; // 4-я карточка (индекс 3)
    if (fourthCard) {
      if (isUzbekistanReviews) {
        fourthCard.style.display = ''; // Показываем для узбекской версии
      } else {
        fourthCard.style.display = 'none'; // Скрываем для русской версии
      }
    }
    
    // Обновляем слайдер после скрытия/показа карточки (для мобильной версии)
    // Используем задержку, чтобы убедиться, что display применился
    if (typeof window.updateParentReviewsSliderPosition === 'function') {
      setTimeout(() => {
        window.updateParentReviewsSliderPosition();
      }, 100);
    }
  }
  
  // Обновляем каждую карточку статическими данными только если отзывов из CMS нет
  if (!hasCmsReviews && parentReviewCards.length > 0) {
    // Данные для русской версии (3 карточки)
    const russiaReviews = [
      {
        image: '/landing_2025/src/img/All/islands-68.webp',
        name: t.parent_review_name_1, // Екатерина Белая
        text: t.parent_review_text_1,
        date: '14 сентября 2024',
        rating: '5.0'
      },
      {
        image: '/landing_2025/src/img/All/islands-68 (1).webp',
        name: t.parent_review_name_2, // Альбина Арбенина
        text: t.parent_review_text_2,
        date: '03 августа 2024',
        rating: '5.0'
      },
      {
        image: '/landing_2025/src/img/All/islands-68 (2).webp',
        name: t.parent_review_name_3, // Марина Воронина
        text: t.parent_review_text_3,
        date: '19 март 2023',
        rating: '3.0'
      }
    ];
    
    // Данные для узбекской версии (4 карточки)
    const uzbekistanReviews = [
      {
        image: '/landing_2025/src/img/All/islands-68.webp',
        name: t.parent_review_name_1_uzbekistan || 'Yunusova Sabina',
        text: t.parent_review_text_1_uzbekistan || '',
        date: t.parent_review_date_1_uzbekistan || '22 июня 2022',
        rating: '5.0'
      },
      {
        image: '/landing_2025/src/img/All/islands-68 (1).webp',
        name: t.parent_review_name_2_uzbekistan || 'Lily Sabi',
        text: t.parent_review_text_2_uzbekistan || '',
        date: t.parent_review_date_2_uzbekistan || '03 августа 2024',
        rating: '5.0'
      },
      {
        image: '/landing_2025/src/img/All/islands-68 (2).webp',
        name: t.parent_review_name_3_uzbekistan || 'Рахимова Лазокатой',
        text: t.parent_review_text_3_uzbekistan || '',
        date: t.parent_review_date_3_uzbekistan || '15 апрель 2025',
        rating: '5.0'
      },
      {
        image: '/landing_2025/src/img/All/islands-68 (2).webp',
        name: t.parent_review_name_4_uzbekistan || 'Sayyora Azimova',
        text: t.parent_review_text_4_uzbekistan || '',
        date: t.parent_review_date_4_uzbekistan || '25 июля 2024',
        rating: '5.0'
      }
    ];
    
    const reviewsData = isUzbekistanReviews ? uzbekistanReviews : russiaReviews;
    const maxCards = isUzbekistanReviews ? 4 : 3;
    
    // Обновляем каждую карточку
    parentReviewCards.forEach((card, cardIndex) => {
      // Пропускаем карточки, которые должны быть скрыты
      if (!isUzbekistanReviews && cardIndex >= 3) {
        return;
      }
      
      const reviewIndex = cardIndex % maxCards;
      const reviewData = reviewsData[reviewIndex];
      
      if (!reviewData) return;
      
      // Обновляем изображение
      const avatarImg = card.querySelector('.block19_review_avatar');
      if (avatarImg) {
        avatarImg.src = reviewData.image;
        avatarImg.alt = reviewData.name;
      }
      
      // Обновляем имя
      const nameEl = card.querySelector('.block19_review_name');
      if (nameEl) {
        nameEl.textContent = reviewData.name;
      }
      
      // Обновляем текст
      const textEl = card.querySelector('.block19_review_text');
      if (textEl) {
        textEl.textContent = reviewData.text;
      }
      
      // Обновляем дату
      const dateEl = card.querySelector('.block19_review_date');
      if (dateEl) {
        // Для обеих версий используем даты как есть (они уже в правильном формате)
        dateEl.textContent = reviewData.date;
      }
      
      // Обновляем рейтинг
      const ratingValueEl = card.querySelector('.block19_review_rating_value');
      if (ratingValueEl) {
        ratingValueEl.textContent = `(${reviewData.rating})`;
      }
      
      // Обновляем количество звезд (5 звезд для всех, но это уже установлено в HTML)
      const starsContainer = card.querySelector('.block19_review_stars');
      if (starsContainer) {
        const stars = starsContainer.querySelectorAll('.star');
        stars.forEach(star => star.textContent = '★');
      }
      
      // Обновляем иконку платформы
      // Список авторов с Яндекс: Екатерина Белая, Альбина Арбенина, Lily Sabi, Рахимова Лазокатой, Sayyora Azimova
      // Список авторов с 2ГИС: Yunusova Sabina, Марина Воронина
      const yandexNames = ['Екатерина Белая', 'Альбина Арбенина', 'Lily Sabi', 'Рахимова Лазокатой', 'Sayyora Azimova'];
      const gis2Names = ['Yunusova Sabina', 'Марина Воронина'];
      
      let iconType = null;
      if (yandexNames.includes(reviewData.name)) {
        iconType = 'yandex';
      } else if (gis2Names.includes(reviewData.name)) {
        iconType = '2gis';
      }
      
      // Находим или создаем контейнер для иконки
      let iconContainer = card.querySelector('.block19_review_icon');
      if (!iconContainer) {
        iconContainer = document.createElement('div');
        iconContainer.className = 'block19_review_icon';
        card.appendChild(iconContainer);
      }
      
      // Обновляем иконку
      if (iconType) {
        const iconSrc = iconType === 'yandex'
          ? landingAssetPath('/landing_2025/src/img/icons-extra/Yandex1.svg')
          : landingAssetPath('/landing_2025/src/img/icons-extra/2gis.svg');
        const iconAlt = iconType === 'yandex' ? 'Yandex' : '2GIS';
        
        let iconImg = iconContainer.querySelector('.review_platform_icon');
        if (!iconImg) {
          iconImg = document.createElement('img');
          iconImg.className = 'review_platform_icon';
          iconContainer.appendChild(iconImg);
        }
        iconImg.src = iconSrc;
        iconImg.alt = iconAlt;
        iconContainer.style.display = 'block';
      } else {
        iconContainer.style.display = 'none';
      }
    });
  }
  
  // Обновляем текст кнопок "Развернуть/Свернуть"
  parentReviewExpands.forEach(btn => {
    const card = btn.closest('.block19_review_card');
    if (card && card.classList.contains('expanded')) {
      btn.textContent = t.block19_review_collapse;
    } else {
      btn.textContent = t.block19_review_expand;
    }
  });

  // Block19_reviews - Форма отзыва
  const block19ReviewsFormTitle = document.querySelector('.block19_reviews_form_title');
  if (block19ReviewsFormTitle) block19ReviewsFormTitle.textContent = t.block19_reviews_form_title;

  const reviewFormLabels = document.querySelectorAll('.block19_reviews_form_group label');
  reviewFormLabels.forEach(label => {
    const forAttr = label.getAttribute('for');
    if (forAttr === 'review_name') {
      label.textContent = t.block19_reviews_form_name;
    } else if (forAttr === 'review_email') {
      label.textContent = t.block19_reviews_form_email;
    } else if (forAttr === 'review_rating') {
      label.textContent = t.block19_reviews_form_rating;
    } else if (forAttr === 'review_text') {
      label.textContent = t.block19_reviews_form_text;
    }
  });

  const reviewNameInput = document.getElementById('review_name');
  if (reviewNameInput) reviewNameInput.placeholder = t.block19_reviews_form_name_placeholder;

  const reviewEmailInput = document.getElementById('review_email');
  if (reviewEmailInput) reviewEmailInput.placeholder = t.block19_reviews_form_email_placeholder;

  const reviewTextInput = document.getElementById('review_text');
  if (reviewTextInput) reviewTextInput.placeholder = t.block19_reviews_form_text_placeholder;

  const reviewFormSubmit = document.querySelector('.block19_reviews_form_submit');
  if (reviewFormSubmit) reviewFormSubmit.textContent = t.block19_reviews_form_submit;

  // Block20 - Email рассылка
  const block20Title = document.querySelector('.block20_title');
  if (block20Title) block20Title.textContent = t.block20_title;

  const block20Description = document.querySelector('.block20_description');
  if (block20Description) block20Description.textContent = t.block20_description;

  const block20SubmitBtn = document.getElementById('submitBtn20');
  if (block20SubmitBtn && t.block20_submit) {
    block20SubmitBtn.textContent = t.block20_submit;
  }

  const block20Consent = document.querySelector('.block20_consent');
  if (block20Consent) block20Consent.innerHTML = t.block20_consent;

  // Block20_campuses - Кампусы
  // Перевод заголовка "Контакты"
  const block20ContactsTitle = document.querySelector('.block20_contacts_title');
  if (block20ContactsTitle) block20ContactsTitle.textContent = t.block20_contacts_title;
  
  // Перевод кнопок кампусов
  const block20CampusBtnLabels = document.querySelectorAll('.block20_campus_btn_label');
  block20CampusBtnLabels.forEach(label => {
    label.textContent = t.block20_campus_label;
  });

  // Перевод названий кампусов в кнопках
  const block20CampusBtnCities = document.querySelectorAll('.block20_campus_btn_city');
  block20CampusBtnCities.forEach(city => {
    const campusId = city.closest('.block20_campus_btn')?.dataset.campus;
    if (campusId && t[`campus_name_${campusId}`]) {
      city.textContent = t[`campus_name_${campusId}`];
    }
  });

  // Перевод селектора кампуса (на странице детсада нет .block20_campus_btn — используем currentBlock20Campus)
  const block20SelectedCampus = document.getElementById('block20SelectedCampus');
  if (block20SelectedCampus) {
    const campusId = document.querySelector('.block20_campus_btn.active')?.dataset.campus || window.currentBlock20Campus || 'spb';
    if (t[`campus_name_${campusId}`]) {
      block20SelectedCampus.textContent = t[`campus_name_${campusId}`];
    }
  }

  // Перевод опций в выпадающем списке
  const block20CampusOptions = document.querySelectorAll('.block20_campus_option');
  block20CampusOptions.forEach(option => {
    const campusId = option.dataset.campus;
    if (campusId && t[`campus_name_${campusId}`]) {
      option.textContent = t[`campus_name_${campusId}`];
    }
  });

  // Перевод заголовка кампуса
  const block20CampusTitleLabel = document.querySelector('.block20_campus_title_label');
  if (block20CampusTitleLabel) block20CampusTitleLabel.textContent = t.block20_campus_label;

  const block20CampusTitleName = document.querySelector('.block20_campus_title_name');
  if (block20CampusTitleName) {
    const activeCampusId = document.querySelector('.block20_campus_btn.active')?.dataset.campus || window.currentBlock20Campus || 'spb';
    if (t[`campus_name_${activeCampusId}`]) {
      block20CampusTitleName.textContent = t[`campus_name_${activeCampusId}`];
    }
  }

  // Перевод заголовков контактов
  const block20ContactTitles = document.querySelectorAll('.block20_contact_title');
  block20ContactTitles.forEach((title, index) => {
    if (index === 0) {
      title.textContent = t.block20_contact_title_for_applicants;
    } else {
      title.textContent = t.block20_contact_title_for_students;
    }
  });

  // Перевод меток контактов (порядок: Менеджер по приему, Секретарь кампуса, Менеджер по договорам)
  const block20ContactLabels = document.querySelectorAll('.block20_contact_label');
  const labelKeys = [
    'block20_contact_label_admissions_manager',
    'block20_contact_label_campus_secretary',
    'block20_contact_label_contract_manager'
  ];
  block20ContactLabels.forEach((label, index) => {
    if (labelKeys[index] && t[labelKeys[index]]) {
      label.textContent = t[labelKeys[index]];
    }
  });

  // Перевод заголовков адреса и координат
  const block20AddressTitle = document.querySelector('.block20_address_title');
  if (block20AddressTitle) block20AddressTitle.textContent = t.block20_address_title;

  const block20CoordinatesTitle = document.querySelector('.block20_coordinates_title');
  if (block20CoordinatesTitle) block20CoordinatesTitle.textContent = t.block20_coordinates_title;

  // Перевод адреса кампуса (на странице детсада нет .block20_campus_btn — используем currentBlock20Campus)
  const block20AddressValue = document.querySelector('.block20_campuses .block20_address_value') || document.querySelector('.block20_address_value');
  if (block20AddressValue) {
    const activeCampusId = document.querySelector('.block20_campus_btn.active')?.dataset.campus || window.currentBlock20Campus || 'spb';
    const addressKey = `block20_address_${activeCampusId}`;
    if (t[addressKey]) {
      block20AddressValue.textContent = t[addressKey];
    }
  }

  // Перевод графика работы
  const block20HoursTitle = document.querySelector('.block20_hours_title');
  if (block20HoursTitle) block20HoursTitle.textContent = t.block20_hours_title;

  const block20HoursDays = document.querySelectorAll('.block20_hours_day');
  const dayTranslations = {
    'Понедельник:': t.block20_hours_monday,
    'Monday:': t.block20_hours_monday,
    'Вторник:': t.block20_hours_tuesday,
    'Tuesday:': t.block20_hours_tuesday,
    'Среда:': t.block20_hours_wednesday,
    'Wednesday:': t.block20_hours_wednesday,
    'Четверг:': t.block20_hours_thursday,
    'Thursday:': t.block20_hours_thursday,
    'Пятница:': t.block20_hours_friday,
    'Friday:': t.block20_hours_friday,
    'Суббота:': t.block20_hours_saturday,
    'Saturday:': t.block20_hours_saturday,
    'Воскресенье:': t.block20_hours_sunday,
    'Sunday:': t.block20_hours_sunday
  };

  block20HoursDays.forEach(day => {
    const dayText = day.textContent.trim();
    if (dayTranslations[dayText]) {
      day.textContent = dayTranslations[dayText];
    }
  });

  const block20HoursTimes = document.querySelectorAll('.block20_hours_time');
  block20HoursTimes.forEach(time => {
    const timeText = time.textContent.trim();
    if (timeText === 'Закрыто' || timeText === 'Closed') {
      time.textContent = t.block20_hours_closed;
    } else if (timeText === '8:30-17:00' || timeText === '8:30 - 17:00') {
      time.textContent = '8:00-17:00';
    }
  });

  // Block19_students_reviews - Отзывы учеников
  const block19StudentsReviewsTitle = document.querySelector('.block19_students_reviews .block19_reviews_title');
  if (block19StudentsReviewsTitle) {
    // Определяем регион для выбора правильного заголовка
    const isUzbekistanStudentsReviews = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    // Используем специальный ключ для узбекской версии, если он существует, иначе используем стандартный
    const titleKey = isUzbekistanStudentsReviews && t.block19_students_reviews_title_uzbekistan
      ? 'block19_students_reviews_title_uzbekistan'
      : 'block19_students_reviews_title';
    block19StudentsReviewsTitle.textContent = t[titleKey];
  }

  // Получаем только реальные карточки (без клонов), как в отзывах родителей
  const studentReviewCards = document.querySelectorAll('#studentReviewsSlides .block19_review_card:not(.block19-student-review-card-clone)');
  if (studentReviewCards.length >= 3) {
    // Определяем регион для выбора правильных отзывов
    const isUzbekistanStudentsReviews = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    
    // Данные для русской версии (3 карточки)
    const russiaStudentReviews = [
      {
        image: landingAssetPath('/landing_2025/src/img/All/Alina.webp'),
        name: t.student_review_name_1, // Алина
        year: t.student_review_year_1, // Выпускница
        campus: t.student_review_campus_1, // Кампус Санкт-Петербург
        text: t.student_review_text_1
      },
      {
        image: landingAssetPath('/landing_2025/src/img/All/Leya.webp'),
        name: t.student_review_name_2, // Лея
        year: t.student_review_year_2, // Выпускница
        campus: t.student_review_campus_2, // Кампус Сколково
        text: t.student_review_text_2
      },
      {
        image: landingAssetPath('/landing_2025/src/img/All/Gleb.webp'),
        name: t.student_review_name_3, // Глеб
        year: t.student_review_year_3, // Ученик Year 11
        campus: t.student_review_campus_3, // Кампус Сколково
        text: t.student_review_text_3
      }
    ];
    
    // Данные для узбекской версии (3 карточки) - используем ключи переводов, которые автоматически выбираются в зависимости от языка (ru или en)
    const uzbekistanStudentReviews = [
      {
        image: landingAssetPath('/landing_2025/src/img/All/Saidah.webp'),
        name: t.student_review_name_1_uzbekistan,
        year: t.student_review_year_1_uzbekistan,
        campus: t.student_review_campus_1_uzbekistan,
        text: t.student_review_text_1_uzbekistan
      },
      {
        image: landingAssetPath('/landing_2025/src/img/All/Sinch.webp'),
        name: t.student_review_name_2_uzbekistan,
        year: t.student_review_year_2_uzbekistan,
        campus: t.student_review_campus_2_uzbekistan,
        text: t.student_review_text_2_uzbekistan
      },
      {
        image: landingAssetPath('/landing_2025/src/img/All/Salar.webp'),
        name: t.student_review_name_3_uzbekistan,
        year: t.student_review_year_3_uzbekistan,
        campus: t.student_review_campus_3_uzbekistan,
        text: t.student_review_text_3_uzbekistan
      }
    ];
    
    const studentReviewsData = isUzbekistanStudentsReviews ? uzbekistanStudentReviews : russiaStudentReviews;
    
    // Обновляем каждую карточку отдельно
    studentReviewCards.forEach((card, cardIndex) => {
      if (cardIndex >= studentReviewsData.length) return;
      
      const reviewData = studentReviewsData[cardIndex];
      if (!reviewData) return;
      
      // Обновляем изображение
      const avatarImg = card.querySelector('.block19_review_avatar');
      if (avatarImg) {
        avatarImg.src = reviewData.image;
        avatarImg.alt = reviewData.name;
      }
      
      // Обновляем имя
      const nameEl = card.querySelector('.block19_review_name');
      if (nameEl) {
        nameEl.textContent = reviewData.name;
      }
      
      // Обновляем год/статус
      const yearEl = card.querySelector('.block19_review_year');
      if (yearEl) {
        yearEl.textContent = reviewData.year;
      }
      
      // Обновляем кампус
      const campusEl = card.querySelector('.block19_review_campus');
      if (campusEl) {
        campusEl.textContent = reviewData.campus;
      }
      
      // Обновляем текст
      const textEl = card.querySelector('.block19_review_text');
      if (textEl) {
        textEl.textContent = reviewData.text;
      }
      
      // Обновляем текст кнопки "Развернуть/Свернуть"
      const expandBtn = card.querySelector('.block19_review_expand');
      if (expandBtn) {
        const isExpanded = card.classList.contains('expanded');
        expandBtn.textContent = isExpanded ? t.block19_review_collapse : t.block19_review_expand;
      }
    });
    
    // Обновляем слайдер после обновления карточек (для мобильной версии)
    if (typeof window.updateStudentReviewsSliderPosition === 'function') {
      setTimeout(() => {
        window.updateStudentReviewsSliderPosition();
      }, 100);
    }
  }

  // Инициализация звёзд рейтинга в отзывах (Block19)
  function initBlock19ReviewStars() {
    const ratingBlocks = document.querySelectorAll('.block19_review_rating');
    ratingBlocks.forEach(ratingBlock => {
      const valueEl = ratingBlock.querySelector('.block19_review_rating_value');
      const stars = ratingBlock.querySelectorAll('.block19_review_stars .star');
      if (!valueEl || stars.length === 0) return;

      // Парсим числовое значение рейтинга, например "(5.0)" -> 5
      const match = valueEl.textContent.match(/([0-9]+(?:\.[0-9]+)?)/);
      if (!match) return;
      const rating = parseFloat(match[1]);
      const filledCount = Math.round(rating);

      stars.forEach((star, index) => {
        if (index < filledCount) {
          star.style.color = '#FFD700'; // жёлтая звезда
        } else {
          star.style.color = '#CCCCCC'; // пустая серая звезда
        }
      });
    });
  }

  // Запускаем инициализацию звёзд рейтинга
  initBlock19ReviewStars();

  // Перевод антиботов (capcha)
  // Обновляем капчи в формах form_hover_a и form_hover_b через updateAllAntibotLabels
  // Сначала обновляем все капчи с классом .capcha
  const capchaLabels = document.querySelectorAll('.capcha, .capcha_label');
  capchaLabels.forEach(label => {
    // Пропускаем block7 - для него есть специальная обработка выше
    if (label.id === 'antibotLabelBlock7') {
      return;
    }

    if (label.closest('.apply-now-form')) {
      return;
    }
    
    const currentText = label.textContent.trim();
    const innerHTML = label.innerHTML;
    
    // Проверяем data-question атрибут (для block7 и других форм с статической капчей)
    let dataQuestion = label.getAttribute('data-question');
    // Если data-question не найден, проверяем текст label
    if (!dataQuestion) {
      const labelText = label.textContent.trim();
      // Извлекаем числа из текста (поддерживаем разные форматы: "What is 14-7", "Сколько будет 14 - 4", и т.д.)
      const match = labelText.match(/(\d+)\s*(?:-|минус|minus)\s*(\d+)/i);
      if (match) {
        dataQuestion = `${match[1]} - ${match[2]}`;
      }
    }
    
    if (dataQuestion) {
      // Извлекаем числа из data-question (поддерживаем разные форматы)
      const match = dataQuestion.match(/(\d+)\s*(?:-|минус|minus)\s*(\d+)/i);
      if (match) {
        const num1 = match[1];
        const num2 = match[2];
        const questionText = t.antibot_question
          .replace('{num1}', num1)
          .replace('{num2}', num2);
        
        // Обновляем data-question
        label.setAttribute('data-question', questionText);
        
        // Сохраняем span.request если он есть
        const requestSpan = label.querySelector('.request');
        const requestHtml = requestSpan ? requestSpan.outerHTML : '';
        
        label.innerHTML = `${questionText}${requestHtml}`;
        return; // Пропускаем дальнейшую обработку
      }
    }
    
    // Проверяем, содержит ли текст или HTML "Антибот:" или "Antibot:" (для других форм)
    if (currentText.includes('Антибот:') || currentText.includes('Antibot:') || innerHTML.includes('Антибот:') || innerHTML.includes('Antibot:')) {
      // Извлекаем числа из вопроса (поддерживаем как "-", так и "минус"/"minus")
      const match = currentText.match(/(\d+)\s*(?:-|минус|minus)\s*(\d+)/i);
      if (match) {
        const num1 = match[1];
        const num2 = match[2];
        const questionText = t.antibot_question
          .replace('{num1}', num1)
          .replace('{num2}', num2);
        label.textContent = questionText;
        label.setAttribute('data-question', questionText);
      } else {
        // Если не удалось извлечь числа, просто удаляем "Антибот:"
        const newText = currentText.replace(/Антибот:|Antibot:/gi, '').trim();
        label.textContent = newText;
      }
    }
    // Если нет ни data-question, ни префикса, но есть числа в тексте (fallback для block7 и других форм)
    else {
      // Убираем звездочку и другие символы для поиска чисел
      // Также убираем префиксы типа "What is", "Сколько будет" и т.д.
      const cleanText = currentText
        .replace(/\*/g, '')
        .replace(/^(What is|Сколько будет|сколько будет)\s*/i, '')
        .trim();
      const match = cleanText.match(/(\d+)\s*(?:-|минус|minus)\s*(\d+)/i);
      if (match) {
        const num1 = match[1];
        const num2 = match[2];
        const questionText = t.antibot_question
          .replace('{num1}', num1)
          .replace('{num2}', num2);
        
        // Сохраняем span.request если он есть
        const requestSpan = label.querySelector('.request');
        const requestHtml = requestSpan ? requestSpan.outerHTML : '<span class="request">*</span>';
        
        // Обновляем data-question если его еще нет
        if (!label.getAttribute('data-question')) {
          label.setAttribute('data-question', questionText);
        }
        
        // При > 768px устанавливаем текст с <br>, но CSS скроет его (display: none), поэтому текст будет на одной строке
        label.innerHTML = `${questionText} ${requestHtml}`;
      }
    }
  });

  // Перевод кнопок "Далее" в формах
  const submitButtons = document.querySelectorAll('.submit[type="submit"]');
  submitButtons.forEach(btn => {
    const btnText = btn.textContent.trim();
    if (btnText === 'Далее' || btnText === 'Next') {
      btn.textContent = t.form_submit_next;
    }
  });

  // Block21 - Footer
  const block21Container = document.querySelector('.block21_container');
  if (block21Container) {
    // Определяем регион для футера
    const isUzbekistanBlock21 = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    
    // Перевод заголовков колонок
    const block21Titles = block21Container.querySelectorAll('.block21_column_title');
    block21Titles.forEach(title => {
      const titleText = title.textContent.trim();
      const titleMap = {
        'Мир CIS': t.block21_world,
        'CIS World': t.block21_world,
        'Программа': t.block21_program,
        'Program': t.block21_program,
        'Преподаватели': t.block21_teachers,
        'Teachers': t.block21_teachers,
        'Поступление': t.block21_admission,
        'Admission': t.block21_admission,
        'Стоимость': t.block21_cost,
        'Cost': t.block21_cost,
        'Кампусы': t.block21_campuses,
        'Campuses': t.block21_campuses,
        'Youngzine Media': t.block21_media
      };
      if (titleMap[titleText]) {
        title.textContent = titleMap[titleText];
      }
    });

    // Перевод ссылок в колонках
    const block21Links = block21Container.querySelectorAll('.block21_link');
    // Определяем правильные тексты для программ в зависимости от региона
    const cambridgeProgramText = isUzbekistanBlock21 && t.block21_program_cambridge_uz ? t.block21_program_cambridge_uz : t.block21_program_cambridge;
    const russianProgramText = isUzbekistanBlock21 && t.block21_program_russian_uz ? t.block21_program_russian_uz : t.block21_program_russian;
    
    block21Links.forEach(link => {
      const linkText = link.textContent.trim();
      const linkMap = {
        // Мир CIS
        'O CIS': t.block21_world_about,
        'About CIS': t.block21_world_about,
        'Миссия и ценности': t.block21_world_mission,
        'Mission and values': t.block21_world_mission,
        'Mission & Values': t.block21_world_mission,
        'Ассоциация выпускников': t.block21_world_alumni,
        'Alumni Association': t.block21_world_alumni,
        'Лицензии': t.block21_world_licenses,
        'Licenses': t.block21_world_licenses,
        'Licences': t.block21_world_licenses,
        'Инновационное оснащение': t.block21_world_equipment,
        'Innovative equipment': t.block21_world_equipment,
        'Innovative Facilities': t.block21_world_equipment,
        'Отзывы': t.block21_world_reviews,
        'Reviews': t.block21_world_reviews,
        'Вакансии': t.block21_world_vacancies,
        'Vacancies': t.block21_world_vacancies,
        'Careers': t.block21_world_vacancies,
        'Контакты': t.block21_world_contacts,
        'Contacts': t.block21_world_contacts,
        'Contact Us': t.block21_world_contacts,
        // Программа - используем разные тексты в зависимости от региона
        'Кембриджская программа': cambridgeProgramText,
        'Международная': cambridgeProgramText,
        'Международная программа': cambridgeProgramText,
        'Cambridge program': cambridgeProgramText,
        'Cambridge Program': cambridgeProgramText,
        'International Programme': cambridgeProgramText,
        'International Program': cambridgeProgramText,
        'Cambridge Programme': cambridgeProgramText,
        'Российская программа': russianProgramText,
        'Russian program': russianProgramText,
        'Russian Program': russianProgramText,
        'Russian Programme': russianProgramText,
        'National Programme': russianProgramText,
        'Локальная программа': russianProgramText,
        'Local program': russianProgramText,
        'Local Programme': russianProgramText,
        'Детский сад': t.block21_program_kindergarten,
        'Kindergarten': t.block21_program_kindergarten,
        'Early Years': t.block21_program_kindergarten,
        'Начальная школа': t.block21_program_primary,
        'Primary school': t.block21_program_primary,
        'Primary School': t.block21_program_primary,
        'Средняя школа': t.block21_program_middle,
        'Middle school': t.block21_program_middle,
        'Secondary School': t.block21_program_middle,
        'Старшая школа': t.block21_program_high,
        'High school': t.block21_program_high,
        'High School': t.block21_program_high,
        'Senior School': t.block21_program_high,
        'Факультативные занятия': t.block21_program_elective,
        'Elective classes': t.block21_program_elective,
        'Elective Classes': t.block21_program_elective,
        'Co-curricular Activities': t.block21_program_elective,
        'Школьный календарь': t.block21_program_calendar,
        'School calendar': t.block21_program_calendar,
        'School Calendar': t.block21_program_calendar,
        // Преподаватели
        'Все': t.block21_teachers_all,
        'All': t.block21_teachers_all,
        'Администрация': t.block21_teachers_admin,
        'Administration': t.block21_teachers_admin,
        // Поступление
        'Процесс поступления': t.block21_admission_process,
        'Admission process': t.block21_admission_process,
        'Admissions Process': t.block21_admission_process,
        'Подать заявку': t.block21_admission_apply,
        'Submit application': t.block21_admission_apply,
        'Submit an Application': t.block21_admission_apply,
        'Тестирование': t.block21_admission_testing,
        'Testing': t.block21_admission_testing,
        'Assessment': t.block21_admission_testing,
        'Документы': t.block21_admission_documents,
        'Documents': t.block21_admission_documents,
        'Required Documents': t.block21_admission_documents,
        'День открытых дверей': t.block21_admission_open_days,
        'Open day': t.block21_admission_open_days,
        'Open Day': t.block21_admission_open_days,
        // Стоимость
        'Стоимость обучения': t.block21_cost_tuition,
        'Tuition cost': t.block21_cost_tuition,
        'Tuition Cost': t.block21_cost_tuition,
        'Tuition Fees': t.block21_cost_tuition,
        'Fees': t.block21_cost_tuition,
        // Названия кампусов (используются в колонках "Стоимость" и "Кампусы")
        'Сколково': t.campus_name_skolkovo,
        'Skolkovo': t.campus_name_skolkovo,
        'Горки': t.campus_name_gorki,
        'Gorki': t.campus_name_gorki,
        'Москва': t.campus_name_moscow,
        'Moscow': t.campus_name_moscow,
        'Санкт-Петербург': t.campus_name_spb,
        'St. Petersburg': t.campus_name_spb,
        'Saint Petersburg': t.campus_name_spb,
        'Ташкент': t.campus_name_tashkent,
        'Tashkent': t.campus_name_tashkent,
        // Кампусы (уже обработано выше через "Все": t.block21_teachers_all, но для консистентности можно использовать block21_campuses_all)
        // Youngzine Media
        'Все записи': t.block21_media_all,
        'All Posts': t.block21_media_all,
        'Журнал Youngzine': t.block21_media_journal,
        'Youngzine Journal': t.block21_media_journal,
        'Youngzine Magazine': t.block21_media_journal,
        'Статьи': t.block21_media_articles,
        'Articles': t.block21_media_articles,
        'Новости': t.block21_media_news,
        'News': t.block21_media_news
      };
      if (linkMap[linkText]) {
        link.textContent = linkMap[linkText];
      }
    });
    
    // Изменение порядка элементов в колонках "Стоимость" и "Кампусы" для узбекской версии
    const block21Columns = block21Container.querySelectorAll('.block21_column');
    block21Columns.forEach(column => {
      const columnTitle = column.querySelector('.block21_column_title');
      if (!columnTitle) return;
      
      const titleText = columnTitle.textContent.trim();
      const columnList = column.querySelector('.block21_column_list');
      if (!columnList) return;
      
      const listItems = Array.from(columnList.querySelectorAll('li'));
      
      // Колонка "Стоимость"
      if (titleText === t.block21_cost || titleText === 'Стоимость' || titleText === 'Cost') {
        if (isUzbekistanBlock21 && listItems.length >= 6) {
          // Находим элемент "Ташкент" (последний в исходном порядке)
          const tashkentItem = listItems.find(item => {
            const link = item.querySelector('a');
            return link && (link.textContent.trim() === t.campus_name_tashkent || link.textContent.trim() === 'Ташкент' || link.textContent.trim() === 'Tashkent');
          });
          // Находим элемент "Стоимость обучения" (первый)
          const tuitionItem = listItems[0];
          
          if (tashkentItem && tuitionItem && tashkentItem !== tuitionItem) {
            // Перемещаем Ташкент на вторую позицию (после "Стоимость обучения")
            columnList.insertBefore(tashkentItem, tuitionItem.nextSibling);
          }
        } else if (!isUzbekistanBlock21 && listItems.length >= 6) {
          // Для русской версии возвращаем исходный порядок
          const tashkentItem = listItems.find(item => {
            const link = item.querySelector('a');
            return link && (link.textContent.trim() === t.campus_name_tashkent || link.textContent.trim() === 'Ташкент' || link.textContent.trim() === 'Tashkent');
          });
          if (tashkentItem && tashkentItem !== listItems[listItems.length - 1]) {
            columnList.appendChild(tashkentItem);
          }
        }
      }
      
      // Колонка "Кампусы"
      if (titleText === t.block21_campuses || titleText === 'Кампусы' || titleText === 'Campuses') {
        if (isUzbekistanBlock21 && listItems.length >= 6) {
          // Находим элемент "Ташкент" (последний в исходном порядке)
          const tashkentItem = listItems.find(item => {
            const link = item.querySelector('a');
            return link && (link.textContent.trim() === t.campus_name_tashkent || link.textContent.trim() === 'Ташкент' || link.textContent.trim() === 'Tashkent');
          });
          // Находим элемент "Все" (первый)
          const allItem = listItems[0];
          
          if (tashkentItem && allItem && tashkentItem !== allItem) {
            // Перемещаем Ташкент на вторую позицию (после "Все")
            columnList.insertBefore(tashkentItem, allItem.nextSibling);
          }
        } else if (!isUzbekistanBlock21 && listItems.length >= 6) {
          // Для русской версии возвращаем исходный порядок
          const tashkentItem = listItems.find(item => {
            const link = item.querySelector('a');
            return link && (link.textContent.trim() === t.campus_name_tashkent || link.textContent.trim() === 'Ташкент' || link.textContent.trim() === 'Tashkent');
          });
          if (tashkentItem && tashkentItem !== listItems[listItems.length - 1]) {
            columnList.appendChild(tashkentItem);
          }
        }
      }
    });
    
    // Пункт "Устав" в футере только для Узбекистана
    const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    const charterFooterLinks = block21Container.querySelectorAll('.js-charter-footer');
    charterFooterLinks.forEach(link => {
      link.style.display = isUzbekistan ? '' : 'none';
      if (isUzbekistan) {
        link.textContent = t.block21_world_charter;
      }
    });

    // Перевод копирайта
    const block21Copyright = block21Container.querySelector('.block21_copyright');
    if (block21Copyright) {
      block21Copyright.textContent = t.block21_copyright;
    }
  }

  // Обновляем атрибут lang у html
  document.documentElement.lang = lang;
  
  // Сохраняем выбранный язык
  localStorage.setItem('siteLanguage', lang);
  window.currentLang = lang;
  
  // Обновляем текст выбранного года в Block12
  const block12SelectedYear = document.getElementById('block12SelectedYear');
  if (block12SelectedYear) {
    const yearMatch = block12SelectedYear.textContent.trim().match(/(\d{4}-\d{4})/);
    if (yearMatch) {
      const year = yearMatch[1];
      const yearSuffix = t.block12_year || (lang === 'en' ? 'year' : 'год');
      block12SelectedYear.textContent = year + ' ' + yearSuffix;
    }
  }
  
  // Обновляем текст info_p в зависимости от размера экрана
  if (typeof updateInfoPText === 'function') {
    updateInfoPText();
  }
  
  // Обновляем контент аккордеонов при изменении размера окна
  updateAlumniAccordionContent();
  updateAlumniAssociationAccordionContent();
  
  // Обновляем отзывы для текущего кампуса при смене языка
  // Определяем текущий кампус из активной кнопки или селектора
  let currentCampusId = 'gorki'; // По умолчанию Горки
  const activeCampusBtn = document.querySelector('.block14_campus_btn.active');
  if (activeCampusBtn) {
    currentCampusId = activeCampusBtn.getAttribute('data-campus') || 'gorki';
  } else {
    // Проверяем селектор кампуса
    const selectedCampus = document.getElementById('block14SelectedCampus');
    if (selectedCampus) {
      const campusText = selectedCampus.textContent.trim();
      // Определяем кампус по тексту
      if (campusText === t.campus_name_tashkent || campusText === 'Ташкент' || campusText === 'Tashkent') {
        currentCampusId = 'tashkent';
      } else if (campusText === t.campus_name_gorki || campusText === 'Горки' || campusText === 'Gorki') {
        currentCampusId = 'gorki';
      } else if (campusText === t.campus_name_skolkovo || campusText === 'Сколково' || campusText === 'Skolkovo') {
        currentCampusId = 'skolkovo';
      } else if (campusText === t.campus_name_moscow || campusText === 'Москва' || campusText === 'Moscow') {
        currentCampusId = 'moscow';
      } else if (campusText === t.campus_name_spb || campusText === 'Санкт-Петербург' || campusText === 'St. Petersburg') {
        currentCampusId = 'spb';
      }
    }
  }
  
  // Обновляем отзывы для текущего кампуса
  if (typeof window.updateReviewsForCampus === 'function') {
    setTimeout(() => {
      window.updateReviewsForCampus(currentCampusId);
    }, 100);
  }
  
  // Обновляем переводы block6 после небольшой задержки, чтобы убедиться, что слайдер не перезаписал тексты
  setTimeout(() => {
    updateBlock6Translations(lang);
  }, 100);
  
  // Обновляем все каптчи при смене языка (с небольшой задержкой, чтобы язык успел сохраниться)
  // НЕ вызываем updateAllAntibotLabels для block7, так как он уже обработан выше
  setTimeout(() => {
    if (typeof window.updateAllAntibotLabels === 'function') {
      window.updateAllAntibotLabels();
    }
    // Повторно обновляем block7 после updateAllAntibotLabels, чтобы убедиться, что перевод не перезаписан
    const antibotLabelBlock7 = document.getElementById('antibotLabelBlock7');
    if (antibotLabelBlock7 && t.antibot_question) {
      let num1 = null;
      let num2 = null;
      const dataQuestion = antibotLabelBlock7.getAttribute('data-question');
      if (dataQuestion) {
        const match = dataQuestion.match(/(\d+)\s*(?:-|минус|minus)\s*(\d+)/i);
        if (match && match[1] && match[2]) {
          num1 = match[1];
          num2 = match[2];
        }
      }
      if (!num1 || !num2) {
        const labelText = antibotLabelBlock7.textContent.trim();
        const cleanText = labelText.replace(/\*/g, '').replace(/<[^>]*>/g, '').trim();
        const match = cleanText.match(/(\d+)\s*(?:-|минус|minus)\s*(\d+)/i);
        if (match && match[1] && match[2]) {
          num1 = match[1];
          num2 = match[2];
        }
      }
      if (num1 && num2) {
        const questionText = t.antibot_question
          .replace('{num1}', num1)
          .replace('{num2}', num2);
        antibotLabelBlock7.setAttribute('data-question', questionText);
        const requestHtml = '<span class="request">*</span>';
        antibotLabelBlock7.innerHTML = `${questionText} ${requestHtml}`;
      }
    }
  }, 50);
  
  // Обновляем текст кнопки apply с учетом ширины экрана
  if (typeof updateApplyButtonText === 'function') {
    updateApplyButtonText();
  }
  
  // Обновляем названия кампусов в form_step2_campus_image_wrapper для всех форм
  const allCampusImageNames = document.querySelectorAll('.form_step2_campus_name, .form_step2_caption');
  allCampusImageNames.forEach(element => {
    const currentText = element.textContent.trim();
    const campusMap = {
      'Кампус Сколково': 'skolkovo',
      'Кампус Москва': 'moscow',
      'Кампус Горки': 'gorki',
      'Кампус Санкт-Петербург': 'spb',
      'Кампус Ташкент': 'tashkent',
      'Campus Skolkovo': 'skolkovo',
      'Campus Moscow': 'moscow',
      'Campus Gorki': 'gorki',
      'Campus St. Petersburg': 'spb',
      'Campus Saint Petersburg': 'spb',
      'Campus Tashkent': 'tashkent'
    };
    
    let campusKey = null;
    for (const [name, key] of Object.entries(campusMap)) {
      const nameWithoutPrefix = name.replace(/^(Кампус |Campus )/, '');
      if (currentText === name || currentText.includes(nameWithoutPrefix)) {
        campusKey = key;
        break;
      }
    }
    
    // Если не нашли по тексту, пытаемся определить по ID или родительскому элементу
    if (!campusKey) {
      if (element.id) {
        const idMatch = element.id.match(/campusCaption_(\d+)(?:_desktop)?/);
        if (idMatch) {
          const formNum = idMatch[1];
          const form = document.getElementById(`formStep2_${formNum}`);
          if (form) {
            const campusSelect = form.querySelector('select[name="campus"]');
            if (campusSelect && campusSelect.value) {
              campusKey = campusSelect.value;
            }
          }
        }
      }
      
      if (!campusKey) {
        const wrapper = element.closest('.form_step2_campus_image_wrapper');
        if (wrapper) {
          const imageEl = wrapper.querySelector('.form_step2_campus_image');
          if (imageEl && imageEl.id) {
            const idMatch = imageEl.id.match(/campusImage_(\d+)/);
            if (idMatch) {
              const formNum = idMatch[1];
              const form = document.getElementById(`formStep2_${formNum}`);
              if (form) {
                const campusSelect = form.querySelector('select[name="campus"]');
                if (campusSelect && campusSelect.value) {
                  campusKey = campusSelect.value;
                }
              }
            }
          }
        }
      }
    }
    
    if (campusKey && t[`campus_name_${campusKey}`]) {
      const campusName = t[`campus_name_${campusKey}`];
      // Убираем <br /> и префикс "Кампус "/"Campus ", чтобы не дублировать слово "кампус"
      const cleanName = campusName.replace(/<br\s*\/?>/gi, ' ').trim().replace(/^(Кампус |Campus )/i, '');
      const newText = lang === 'en' ? `Campus ${cleanName}` : `Кампус ${cleanName}`;
      element.textContent = newText;
    }
  });
}

// Экспортируем функцию translatePage в глобальную область видимости
window.translatePage = translatePage;

function cleanupLogoSchoolRow() {
  document.querySelectorAll('.top_bar .logo_school_row').forEach((row) => {
    Array.from(row.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        node.remove();
      }
    });
  });
}
window.cleanupLogoSchoolRow = cleanupLogoSchoolRow;
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', cleanupLogoSchoolRow);
} else {
  cleanupLogoSchoolRow();
}

// Функция для обновления текста кнопки apply в зависимости от ширины экрана
function updateApplyButtonText() {
  const applyBtn = document.querySelector('.top_bar .icons a.apply');
  if (!applyBtn) return;
  
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
  
  if (window.innerWidth <= 768 && lang === 'en') {
    // При 768px и меньше для английского языка показываем "Apply"
    applyBtn.textContent = 'Apply';
  } else {
    // Для русского языка и при ширине больше 768px показываем стандартный текст из переводов
    if (t && t.apply) {
      applyBtn.textContent = t.apply;
    }
  }
}

// Добавляем обработчик resize для обновления текста кнопки apply
let applyButtonResizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(applyButtonResizeTimeout);
  applyButtonResizeTimeout = setTimeout(() => {
    updateApplyButtonText();
  }, 100);
});

// Вызываем при загрузке страницы
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(updateApplyButtonText, 100);
  });
} else {
  setTimeout(updateApplyButtonText, 100);
}

// Функция для перевода элементов step2 формы
function translateStep2Form(formId) {
  const form = document.getElementById(formId);
  if (!form) return;
  
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
  if (!t) return;
  
  // Переводим лейблы
  const formStep2Labels = form.querySelectorAll('.form_step2_input_wrapper label');
  formStep2Labels.forEach(label => {
    const forAttr = label.getAttribute('for');
    if (forAttr) {
      // Проверяем, есть ли звездочка ДО изменения innerHTML
      const hasRequired = label.querySelector('.required') !== null;
      const requiredHtml = hasRequired ? ' <span class="required">*</span>' : '';
      
      if (forAttr.includes('parent_name')) {
        label.innerHTML = t.form_parent_name + requiredHtml;
      } else if (forAttr.includes('email')) {
        label.innerHTML = t.form_email + requiredHtml;
      } else if (forAttr.includes('child_name')) {
        label.innerHTML = t.form_child_name + requiredHtml;
      } else if (forAttr.includes('birth_date')) {
        label.innerHTML = t.form_birth_date + requiredHtml;
      } else if (forAttr.includes('campus')) {
        label.innerHTML = t.form_campus + requiredHtml;
      } else if (forAttr.includes('phone_step2')) {
        label.innerHTML = t.form_phone + requiredHtml;
      } else if (forAttr.includes('request_kind')) {
        label.innerHTML = (t.form_request_kind || 'Тип заявки') + requiredHtml;
      }
    }
  });
  
  // Переводим placeholder для birth_date
  const birthDateInputs = form.querySelectorAll('input[name="birth_date"]');
  birthDateInputs.forEach(input => {
    if (input.placeholder) {
      input.placeholder = lang === 'ru' ? 'xx.xx.xxxx' : 'xx.xx.xxxx';
    }
  });

  // Переводим placeholder для child_name
  const childNameInputs = form.querySelectorAll('input[name="child_name"]');
  childNameInputs.forEach(input => {
    if (input.placeholder && t.form_child_name_placeholder) {
      input.placeholder = t.form_child_name_placeholder;
    }
  });

  // Переводим placeholder для campus select
  const campusSelectsForm = form.querySelectorAll('select[name="campus"]');
  campusSelectsForm.forEach(select => {
    const firstOption = select.querySelector('option[value=""]');
    if (firstOption && t.campus_select_placeholder) {
      firstOption.textContent = t.campus_select_placeholder;
    }
  });
  
  // Переводим кнопку submit
  const submitBtn = form.querySelector('#submitStep2_1, #submitStep2_2, #submitStep2_3, #submitStep2_4, #submitStep2_apply_now');
  if (submitBtn) {
    submitBtn.textContent = t.form_submit;
  }
  
  // Переводим названия кампусов в form_step2_campus_image_wrapper и form_step2_caption
  const campusImageNames = form.querySelectorAll('.form_step2_campus_name, .form_step2_caption');
  campusImageNames.forEach(element => {
    const currentText = element.textContent.trim();
    // Пытаемся определить кампус по тексту
    const campusMap = {
      'Кампус Сколково': 'skolkovo',
      'Кампус Москва': 'moscow',
      'Кампус Горки': 'gorki',
      'Кампус Санкт-Петербург': 'spb',
      'Кампус Ташкент': 'tashkent',
      'Campus Skolkovo': 'skolkovo',
      'Campus Moscow': 'moscow',
      'Campus Gorki': 'gorki',
      'Campus St. Petersburg': 'spb',
      'Campus Saint Petersburg': 'spb',
      'Campus Tashkent': 'tashkent'
    };
    
    let campusKey = null;
    for (const [name, key] of Object.entries(campusMap)) {
      if (currentText === name || currentText.includes(name.replace('Кампус ', '')) || currentText.includes(name.replace('Campus ', ''))) {
        campusKey = key;
        break;
      }
    }
    
    // Если не нашли по тексту, пытаемся определить по ID или select
    if (!campusKey) {
      if (element.id) {
        const idMatch = element.id.match(/campusCaption_(\d+)(?:_desktop)?/);
        if (idMatch) {
          const campusSelect = form.querySelector('select[name="campus"]');
          if (campusSelect && campusSelect.value) {
            campusKey = campusSelect.value;
          }
        }
      }
      
      if (!campusKey) {
        const wrapper = element.closest('.form_step2_campus_image_wrapper');
        if (wrapper) {
          const imageEl = wrapper.querySelector('.form_step2_campus_image');
          if (imageEl && imageEl.id) {
            const idMatch = imageEl.id.match(/campusImage_(\d+)/);
            if (idMatch) {
              const campusSelect = form.querySelector('select[name="campus"]');
              if (campusSelect && campusSelect.value) {
                campusKey = campusSelect.value;
              }
            }
          }
        }
      }
    }
    
    if (campusKey && t[`campus_name_${campusKey}`]) {
      const campusName = t[`campus_name_${campusKey}`];
      const cleanName = campusName.replace(/<br\s*\/?>/gi, ' ').trim().replace(/^(Кампус |Campus )/i, '');
      element.textContent = lang === 'en' ? `Campus ${cleanName}` : `Кампус ${cleanName}`;
    }
  });

  // Переводим alt_text
  const altText = form.querySelector('.alt_text, .form_step2_alt_text');
  if (altText && !altText.classList.contains('block20_consent')) {
    // Определяем регион
    const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
      ? window.getCookie(window.COOKIE_NAME)
      : (typeof getCookie === 'function' && typeof COOKIE_NAME !== 'undefined' ? getCookie(COOKIE_NAME) : null);
    let currentRegion = 'Россия';
    if (saved) {
      try {
        const regionData = JSON.parse(saved);
        currentRegion = regionData.name;
      } catch (e) {
        // Если не удалось распарсить, используем значение по умолчанию
      }
    }
    const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    
    // Для Узбекистана - номер +998 (71) 209 66 69, для России - 8 800 551 43 96
    const phoneNumber = isUzbekistan ? '+998 (71) 209 66 69' : '8 800 551 43 96';
    const phoneHref = isUzbekistan ? 'tel:+998712096669' : 'tel:88005514396';
    
    altText.innerHTML = t.form_alt_text + ' <a href="' + phoneHref + '">' + phoneNumber + '</a>';
  }
  
  // Переводим заголовок формы
  const formTitle = form.querySelector('.form_txt');
  if (formTitle) {
    const parent = formTitle.closest('.form_hover, .form_hover_step2');
    if (parent) {
      const isStep2 = parent.classList.contains('form_hover_step2');
      if (isStep2) {
        const formStep2 = formTitle.closest('.form_hover_step2');
        if (formStep2) {
          const hiddenInput = formStep2.querySelector('input[name="form_name"]');
          if (hiddenInput) {
            const formName = hiddenInput.value;
            if (formName.includes('пробный') || formName.includes('trial')) {
              formTitle.textContent = t.form_trial_title;
            } else if (formName.includes('экскурсию') || formName.includes('tour')) {
              formTitle.textContent = t.form_tour_title;
            } else if (formName.includes('тестирование') || formName.includes('testing')) {
              formTitle.textContent = t.form_testing_title;
            } else if (formName.includes('консультацию') || formName.includes('consultation')) {
              formTitle.textContent = t.form_consultation_title;
            } else if (formName.includes('заявк') || formName.includes('Apply') || formName.includes('application')) {
              formTitle.textContent = t.form_apply_title || (lang === 'en' ? 'Apply' : 'Подать заявку');
            }
          }
        }
      }
    }
  }
}

// Экспортируем функцию глобально
window.translateStep2Form = translateStep2Form;

// Функция для обновления переводов block6 (можно вызывать отдельно)
function updateBlock6Translations(lang) {
  const t = translations[lang];
  if (!t) return;

  // Block6 - полные переводы
  const block6Container = document.querySelector('.container_advange') || document.querySelector('#advantages');
  const block6Title = block6Container ? block6Container.querySelector('.advage') : document.querySelector('.advage');
  if (block6Title) block6Title.textContent = t.block6_title;

  // Получаем только реальные карточки (исключаем клоны, созданные слайдером)
  const advantagesGrid = block6Container ? block6Container.querySelector('.advantages_grid') : null;
  const allAdvantageCards = advantagesGrid
    ? advantagesGrid.querySelectorAll('.advantage_card')
    : document.querySelectorAll('.advantage_card');
  const advantageCards = Array.from(allAdvantageCards).filter(card => !card.classList.contains('advantage-card-clone'));
  
  // Определяем регион для выбора правильного текста
  const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
    ? window.getCookie(window.COOKIE_NAME)
    : (typeof getCookie === 'function' && typeof COOKIE_NAME !== 'undefined' ? getCookie(COOKIE_NAME) : null);
  let currentRegion = 'Россия';
  if (saved) {
    try {
      const regionData = JSON.parse(saved);
      currentRegion = regionData.name;
    } catch (e) {
      // Если не удалось распарсить, используем значение по умолчанию
    }
  }
  const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
  
  // Порядок карточек: 0-Две программы, 1-Международная среда, 2-Питание, 3-Безопасность, 4-Кружки, 5-Наши выпускники, 6-Soft skills
  if (advantageCards.length >= 6) {
    // Карточка 0: Две программы
    const card0 = advantageCards[0];
    const title0 = card0.querySelector('.progamms');
    if (title0) title0.textContent = t.block6_programs_title;
    const p0 = card0.querySelector('p');
    if (p0) {
      const programsText = isUzbekistan ? (t.block6_programs_text_uzbekistan || t.block6_programs_text) : t.block6_programs_text;
      p0.innerHTML = programsText;
    }
    const items0 = card0.querySelectorAll('li');
    if (items0.length >= 3) {
      items0[0].textContent = t.block6_programs_item1;
      items0[1].textContent = t.block6_programs_item2;
      items0[2].textContent = t.block6_programs_item3;
    }

    // Карточка 1: Международная среда
    const card1 = advantageCards[1];
    const title1 = card1.querySelector('.progamms');
    if (title1) title1.textContent = t.block6_international_title;
    const items1 = card1.querySelectorAll('li');
    if (items1.length >= 4) {
      items1[0].textContent = t.block6_international_item1;
      items1[1].textContent = t.block6_international_item2;
      items1[2].textContent = t.block6_international_item3;
      items1[3].textContent = t.block6_international_item4;
    }

    // Карточка 2: Питание (теперь на позиции 2)
    const card2 = advantageCards[2];
    const title2 = card2.querySelector('.progamms');
    if (title2) title2.textContent = t.block6_meals_title;
    const items2 = card2.querySelectorAll('li');
    if (items2.length >= 2) {
      items2[0].textContent = t.block6_meals_item1;
      items2[1].textContent = t.block6_meals_item2;
      // Для английского языка добавляем третий пункт, если он есть
      if (items2.length >= 3 && t.block6_meals_item3) {
        items2[2].textContent = t.block6_meals_item3;
        items2[2].style.display = '';
      } else if (items2.length >= 3) {
        items2[2].style.display = 'none';
      }
    }

    // Карточка 3: Безопасность (теперь на позиции 3)
    const card3 = advantageCards[3];
    const title3 = card3.querySelector('.progamms');
    if (title3) title3.textContent = t.block6_safety_title;
    const p3 = card3.querySelector('p');
    if (p3) p3.textContent = t.block6_safety_text;
    const items3 = card3.querySelectorAll('li');
    if (items3.length >= 2) {
      items3[0].textContent = t.block6_safety_item1;
      items3[1].textContent = t.block6_safety_item2;
    }

    // Карточка 4: Кружки
    const card4 = advantageCards[4];
    const title4 = card4.querySelector('.progamms');
    if (title4) title4.textContent = t.block6_clubs_title;
    const p4 = card4.querySelector('p');
    if (p4) {
      const isUzbekistanClubs = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
      p4.innerHTML = isUzbekistanClubs ? (t.block6_clubs_text_uzbekistan || t.block6_clubs_text) : t.block6_clubs_text;
    }
    const items4 = card4.querySelectorAll('li');
    if (items4.length >= 5) {
      items4[0].textContent = t.block6_clubs_item1;
      items4[1].textContent = t.block6_clubs_item2;
      items4[2].textContent = t.block6_clubs_item3;
      items4[3].textContent = t.block6_clubs_item4;
      items4[4].textContent = t.block6_clubs_item5;
    }

    // Карточка 5: Наши выпускники
    const card5 = advantageCards[5];
    const title5 = card5.querySelector('.progamms');
    if (title5) title5.textContent = t.block6_graduates;
    const items5 = card5.querySelectorAll('li');
    if (items5.length >= 2) {
      items5[0].textContent = t.block6_graduates_item1;
      items5[1].textContent = t.block6_graduates_item2;
    }

    // Карточка 6: Soft skills
    const card6 = advantageCards[6];
    const title6 = card6.querySelector('.progamms');
    if (title6) title6.textContent = t.block6_soft_skills;
    const p6 = card6.querySelector('p');
    if (p6) p6.innerHTML = t.block6_soft_skills_text;
    const items6 = card6.querySelectorAll('li');
    if (items6.length >= 4) {
      items6[0].textContent = t.block6_communication;
      items6[1].textContent = t.block6_teamwork;
      items6[2].textContent = t.block6_critical;
      items6[3].textContent = t.block6_creativity;
    }
  }
}

// Экспортируем функцию для использования в других местах
window.updateBlock6Translations = updateBlock6Translations;

// Функция для обновления контента аккордеона "Прием в университеты" при изменении размера окна
function updateAlumniAccordionContent() {
  const firstAlumniAccordionItem = document.querySelector('.alumni_accordion_item');
  const alumniAccordionContent = firstAlumniAccordionItem?.querySelector('.accordion_content');
  
  if (!alumniAccordionContent) return;
  
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
  if (!t) return;
  
  // Определяем текущий регион
  const saved = typeof getCookie !== 'undefined' && typeof COOKIE_NAME !== 'undefined'
    ? getCookie(COOKIE_NAME)
    : (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined'
      ? window.getCookie(window.COOKIE_NAME)
      : null);
  let currentRegion = 'Россия';
  if (saved) {
    try {
      const regionData = JSON.parse(saved);
      currentRegion = regionData.name;
    } catch (e) {
      // Если не удалось распарсить, используем значение по умолчанию
    }
  }
  const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
  
  const isMobile = window.innerWidth <= 768;
  
  // Сохраняем оригинальный HTML при первой загрузке, если еще не сохранен
  if (!alumniAccordionContent.dataset.originalHtml) {
    alumniAccordionContent.dataset.originalHtml = alumniAccordionContent.innerHTML;
  }
  
  if (isMobile) {
    // Мобильная версия: новый текст + изображение
    const mobileHtml = `
      <div class="alumni_content_wrapper">
        <div class="alumni_left_column">
          <p class="alumni_intro">
            ${(() => {
              // Используем версию для Узбекистана, если регион Узбекистан
              let text = (isUzbekistan && t.block15_alumni_intro_mobile_uzbekistan)
                ? t.block15_alumni_intro_mobile_uzbekistan
                : (t.block15_alumni_intro_mobile || t.block15_alumni_intro || '');
              // Сохраняем дефисы внутри скобок (например, Year 11–13)
              text = text.replace(/\(([^)]*–[^)]*)\)/g, (match) => match.replace(/–/g, '___TEMP_DASH___'));
              // Заменяем остальные дефисы на красные
              text = text.replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>');
              // Возвращаем дефисы внутри скобок обратно
              text = text.replace(/___TEMP_DASH___/g, '–');
              return text;
            })()}
          </p>
          
          <div class="alumni_diagram">
            <img src="${landingAssetPath('/landing_2025/src/img/' + (lang === 'en' ? 'alumni Diagram 2013-2024 250225-2_ENG.jpg' : 'alumni Diagram 2013-2024 250225-2_RUS.jpg'))}" alt="${lang === 'en' ? 'University acceptance diagram' : 'Диаграмма поступлений'}" />
          </div>
          
          <div class="alumni_universities_mobile">
            <p><strong>${t.block15_alumni_geography_mobile || 'География поступлений:'}</strong></p>
            <p>${(t.block15_alumni_geography_uk_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            <p>${(t.block15_alumni_geography_usa_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            <p>${(t.block15_alumni_geography_russia_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            <p>${(t.block15_alumni_geography_uzbekistan_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            <p>${(t.block15_alumni_geography_uae_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            <p>${(t.block15_alumni_geography_switzerland_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
          </div>
        </div>
      </div>
    `;
    alumniAccordionContent.innerHTML = mobileHtml;
  } else {
    // Десктопная версия (769px+): используем новый текст как в мобильной версии
    const desktopHtml = `
      <div class="alumni_content_wrapper">
        <div class="alumni_left_column">
          <p class="alumni_intro">
            ${(() => {
              // Используем версию для Узбекистана, если регион Узбекистан
              let text = (isUzbekistan && t.block15_alumni_intro_mobile_uzbekistan)
                ? t.block15_alumni_intro_mobile_uzbekistan
                : (t.block15_alumni_intro_mobile || t.block15_alumni_intro || '');
              // Сохраняем дефисы внутри скобок (например, Year 11–13)
              text = text.replace(/\(([^)]*–[^)]*)\)/g, (match) => match.replace(/–/g, '___TEMP_DASH___'));
              // Заменяем остальные дефисы на красные
              text = text.replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>');
              // Возвращаем дефисы внутри скобок обратно
              text = text.replace(/___TEMP_DASH___/g, '–');
              return text;
            })()}
          </p>
          
          <div class="alumni_diagram">
            <img src="${landingAssetPath('/landing_2025/src/img/' + (lang === 'en' ? 'alumni Diagram 2013-2024 250225-2_ENG.jpg' : 'alumni Diagram 2013-2024 250225-2_RUS.jpg'))}" alt="${lang === 'en' ? 'University acceptance diagram' : 'Диаграмма поступлений'}" />
          </div>
          
          <div class="alumni_universities_mobile">
            <p><strong>${t.block15_alumni_geography_mobile || 'География поступлений:'}</strong></p>
            <p>${(t.block15_alumni_geography_uk_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            <p>${(t.block15_alumni_geography_usa_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            <p>${(t.block15_alumni_geography_russia_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            <p>${(t.block15_alumni_geography_uzbekistan_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            <p>${(t.block15_alumni_geography_uae_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
            <p>${(t.block15_alumni_geography_switzerland_mobile || '').replace(/—/g, '<span class="alumni_university_dash">—</span>').replace(/–/g, '<span class="alumni_university_dash">–</span>')}</p>
          </div>
        </div>
      </div>
    `;
    alumniAccordionContent.innerHTML = desktopHtml;
  }
}

// Функция для обновления контента аккордеона "Ассоциация выпускников" при изменении размера окна
function updateAlumniAssociationAccordionContent() {
  const alumniAccordionItems = document.querySelectorAll('.alumni_accordion_item');
  const secondAlumniAccordionItem = alumniAccordionItems.length >= 2 ? alumniAccordionItems[1] : null;
  const secondAlumniAccordionContent = secondAlumniAccordionItem?.querySelector('.accordion_content');
  
  if (!secondAlumniAccordionContent) return;
  
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
  if (!t) return;
  
  const isMobile = window.innerWidth <= 768;
  
  // Сохраняем оригинальный HTML при первой загрузке, если еще не сохранен
  if (!secondAlumniAccordionContent.dataset.originalHtml) {
    secondAlumniAccordionContent.dataset.originalHtml = secondAlumniAccordionContent.innerHTML;
  }
  
  if (isMobile) {
    // Мобильная версия: новый текст
    const mobileHtml = `
      <div class="alumni_association_content">
        <p class="alumni_association_lead">
          ${t.block15_association_mobile || t.block15_association_lead}
        </p>
        <div class="alumni_association_main">
          <p><strong>${t.block15_association_formats_mobile || 'Форматы взаимодействия:'}</strong></p>
          <p><span class="accordion_dash">—</span> ${t.block15_association_format1_mobile ? t.block15_association_format1_mobile.replace('— ', '') : 'мероприятия и встречи;'}</p>
          <p><span class="accordion_dash">—</span> ${t.block15_association_format2_mobile ? t.block15_association_format2_mobile.replace('— ', '') : 'общение в социальных сетях;'}</p>
          <p><span class="accordion_dash">—</span> ${t.block15_association_format3_mobile ? t.block15_association_format3_mobile.replace('— ', '') : 'программа наставничества;'}</p>
          <p><span class="accordion_dash">—</span> ${t.block15_association_format4_mobile ? t.block15_association_format4_mobile.replace('— ', '') : 'волонтёрство и пожертвования;'}</p>
          <p><span class="accordion_dash">—</span> ${t.block15_association_format5_mobile ? t.block15_association_format5_mobile.replace('— ', '') : 'карьерная поддержка.'}</p>
        </div>
      </div>
    `;
    secondAlumniAccordionContent.innerHTML = mobileHtml;
  } else {
    // Десктопная версия (769px+): используем новый текст как в мобильной версии
    const desktopHtml = `
      <div class="alumni_association_content">
        <p class="alumni_association_lead">
          ${t.block15_association_mobile || t.block15_association_lead}
        </p>
        <div class="alumni_association_main">
          <p><strong>${t.block15_association_formats_mobile || 'Форматы взаимодействия:'}</strong></p>
          <p><span class="accordion_dash">—</span> ${t.block15_association_format1_mobile ? t.block15_association_format1_mobile.replace('— ', '') : 'мероприятия и встречи;'}</p>
          <p><span class="accordion_dash">—</span> ${t.block15_association_format2_mobile ? t.block15_association_format2_mobile.replace('— ', '') : 'общение в социальных сетях;'}</p>
          <p><span class="accordion_dash">—</span> ${t.block15_association_format3_mobile ? t.block15_association_format3_mobile.replace('— ', '') : 'программа наставничества;'}</p>
          <p><span class="accordion_dash">—</span> ${t.block15_association_format4_mobile ? t.block15_association_format4_mobile.replace('— ', '') : 'волонтёрство и пожертвования;'}</p>
          <p><span class="accordion_dash">—</span> ${t.block15_association_format5_mobile ? t.block15_association_format5_mobile.replace('— ', '') : 'карьерная поддержка.'}</p>
        </div>
      </div>
    `;
    secondAlumniAccordionContent.innerHTML = desktopHtml;
  }
}

// Добавляем обработчик resize для обновления контента аккордеонов
let alumniAccordionResizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(alumniAccordionResizeTimeout);
  alumniAccordionResizeTimeout = setTimeout(() => {
    // Обновляем block15_description при изменении размера окна
    const block15Description = document.querySelector('.block15_description');
    if (block15Description) {
      const lang = localStorage.getItem('siteLanguage') || 'ru';
      
      const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
        ? window.getCookie(window.COOKIE_NAME)
        : (typeof getCookie === 'function' && typeof COOKIE_NAME !== 'undefined' ? getCookie(COOKIE_NAME) : null);
      let currentRegion = 'Россия';
      if (saved) {
        try {
          const regionData = JSON.parse(saved);
          currentRegion = regionData.name;
        } catch (e) {
          // Если не удалось распарсить, используем значение по умолчанию
        }
      }
      
      const t = translations[lang];
      if (t) {
        const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
        const descriptionText = isUzbekistan && t.block15_description_mobile_uzbekistan
          ? t.block15_description_mobile_uzbekistan
          : (t.block15_description || '');
        block15Description.innerHTML = descriptionText;
      }
    }
    updateAlumniAccordionContent();
    updateAlumniAssociationAccordionContent();
  }, 100);
});
